export const PRIORAUTH_TURNAROUND_TIME_CANCEL = 'PRIORAUTH_TURNAROUND_TIME_CANCEL';
export const CASE_SUBMISSION_DETAILS_CANCEL = 'CASE_SUBMISSION_DETAILS_CANCEL';
export const NONPAYMENT_DETAILS_DATA_CANCEL = 'NONPAYMENT_DETAILS_DATA_CANCEL';
export const NONPAYMENT_TOP_REASON_DATA_CANCEL = 'NONPAYMENT_TOP_REASON_DATA_CANCEL';
export const NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_CANCEL =
  'NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_CANCEL';
export const NONPAYMENT_COMPLETE_AND_TREND_DATA_CANCEL =
  'NONPAYMENT_COMPLETE_AND_TREND_DATA_CANCEL';

// NonPayment Polling Actions
export const NONPAYMENT_POLLING_STARTED = 'NONPAYMENT_POLLING_STARTED';
export const NONPAYMENT_POLLING_COMPLETED = 'NONPAYMENT_POLLING_COMPLETED';
export const NONPAYMENT_POLLING_FAILED = 'NONPAYMENT_POLLING_FAILED';
export const NONPAYMENT_POLLING_RESET = 'NONPAYMENT_POLLING_RESET';
//SOS Actions
export const GET_SOS_CLAIM_EVENT_DATA_SUCCESS = 'GET_SOS_CLAIM_EVENT_DATA_SUCCESS';
export const GET_SOS_CLAIM_EVENT_DATA_FAILURE = 'GET_SOS_CLAIM_EVENT_DATA_FAILURE';
export const FETCH_SOS_CLAIM_EVENT_DATA_REQUEST = 'FETCH_SOS_CLAIM_EVENT_DATA_REQUEST';
export const GET_SOS_CLAIM_EVENT_DATA = 'GET_SOS_CLAIM_EVENT_DATA';

export const GET_SOS_PROGRAM_DATA = 'GET_SOS_PROGRAM_DATA';
export const GET_FOOTER_DATE = 'GET_FOOTER_DATE';
export const FETCH_SOS_DATA_REQUEST = 'FETCH_SOS_DATA_REQUEST';
export const IS_LOADING = 'IS_LOADING';

export const MARKET_SHARE_DATA_REQUEST = 'MARKET_SHARE_DATA_REQUEST';
export const MARKET_SHARE_DATA_SUCESS = 'MARKET_SHARE_DATA_SUCESS';
export const MARKET_SHARE_DATA_FAILED = 'MARKET_SHARE_DATA_FAILED';
export const SET_MARKET_SHARE_DATA = 'SET_MARKET_SHARE_DATA';
export const GET_MARKET_SHARE_DATA = 'GET_MARKET_SHARE_DATA';

export const GET_TOP_SEARCHED_LIST_REQUEST = 'GET_TOP_SEARCHED_LIST_REQUEST';
export const GET_TOP_SEARCHED_LIST_SUCCESS = 'GET_TOP_SEARCHED_LIST_SUCCESS';
export const GET_TOP_SEARCHED_LIST_FAILURE = 'GET_TOP_SEARCHED_LIST_FAILURE';

export const USER_DETAILS_FETCHED = 'USER_DETAILS_FETCHED';

export const PROVIDER_SEARCH_LOADING = 'PROVIDER_SEARCH_LOADING';

export const PROVIDER_SEARCH_REQUEST = 'PROVIDER_SEARCH_REQUEST';
export const PROVIDER_SEARCH_SUCCESS = 'PROVIDER_SEARCH_SUCCESS';
export const PROVIDER_SEARCH_FAILURE = 'PROVIDER_SEARCH_FAILURE';

export const GET_TAX_ID_SEARCH_LIST_REQUEST = 'GET_TAX_ID_SEARCH_LIST_REQUEST';
export const GET_TAX_ID_SEARCH_LIST_SUCCESS = 'GET_TAX_ID_SEARCH_LIST_SUCCESS';
export const GET_TAX_ID_SEARCH_LIST_FAILURE = 'GET_TAX_ID_SEARCH_LIST_FAILURE';

export const GET_GEO_SEGMENTATION_SEARCH_LIST_REQUEST = 'GET_GEO_SEGMENTATION_SEARCH_LIST_REQUEST';
export const GET_GEO_SEGMENTATION_SEARCH_LIST_SUCCESS = 'GET_GEO_SEGMENTATION_SEARCH_LIST_SUCCESS';
export const GET_GEO_SEGMENTATION_SEARCH_LIST_FAILURE = 'GET_GEO_SEGMENTATION_SEARCH_LIST_FAILURE';

export const SAVE_SEARCH_DETAILS_REQUEST = 'SAVE_SEARCH_DETAILS_REQUEST';
export const SAVE_SEARCH_DETAILS_SUCCESS = 'SAVE_SEARCH_DETAILS_SUCCESS';
export const SAVE_SEARCH_DETAILS_FAILURE = 'SAVE_SEARCH_DETAILS_FAILURE';

export const SAVE_CONTRACT_SEARCH_DETAILS_REQUEST = 'SAVE_CONTRACT_SEARCH_DETAILS_REQUEST';
export const SAVE_CONTRACT_SEARCH_DETAILS_SUCCESS = 'SAVE_CONTRACT_SEARCH_DETAILS_SUCCESS';
export const SAVE_CONTRACT_SEARCH_DETAILS_FAILURE = 'SAVE_CONTRACT_SEARCH_DETAILS_FAILURE';

export const SAVE_TINS_GROUP_REQUEST = 'SAVE_TINS_GROUP_REQUEST';
export const SAVE_TINS_GROUP_SUCCESS = 'SAVE_TINS_GROUP_SUCCESS';
export const SAVE_TINS_GROUP_FAILURE = 'SAVE_TINS_GROUP_FAILURE';

export const SAVE_GEO_SEARCH_DETAILS_REQUEST = 'SAVE_GEO_SEARCH_DETAILS_REQUEST';
export const SAVE_GEO_SEARCH_DETAILS_SUCCESS = 'SAVE_GEO_SEARCH_DETAILS_SUCCESS';
export const SAVE_GEO_SEARCH_DETAILS_FAILURE = 'SAVE_GEO_SEARCH_DETAILS_FAILURE';

export const UPDATE_NAVIGATION_LINK = 'UPDATE_NAVIGATION_LINK';

export const GET_INDICATOR_DATA_SUCCESS = 'GET_INDICATOR_DATA_SUCCESS';
export const FETCH_INDICATOR_DATA_REQUEST = 'FETCH_INDICATOR_DATA_REQUEST';
export const GET_INDICATOR_DATA_FAILURE = 'GET_INDICATOR_DATA_FAILURE';

export const FETCH_PSMS_INDICATOR_REQUEST = 'FETCH_PSMS_INDICATOR_REQUEST';
export const GET_PSMS_INDICATOR_SUCCESS = 'GET_PSMS_INDICATOR_SUCCESS';
export const GET_PSMS_INDICATOR_FAILURE = 'GET_PSMS_INDICATOR_FAILURE';

export const FETCH_TIN_EXPANSION_REQUEST = 'FETCH_TIN_EXPANSION_REQUEST';
export const TIN_EXPANSION_DATA_SUCCESS = 'TIN_EXPANSION_DATA_SUCCESS';
export const SET_API_TIMING = 'SET_API_TIMING';

export const MPIN_TABLE_DATA_REQUEST = 'MPIN_TABLE_DATA_REQUEST';
export const MPIN_TABLE_DATA_SUCCESS = 'MPIN_TABLE_DATA_SUCCESS';
export const MPIN_TABLE_DATA_FAILURE = 'MPIN_TABLE_DATA_FAILURE';
export const MPIN_TABLE_DATA = 'MPIN_TABLE_DATA';

// Network Management Actions
export const GET_ACTIVE_PROGRAMS_DATA_SUCCESS = 'SET_ACTIVE_PROGRAMS_DATA_SUCCESS';
export const FETCH_ACTIVE_PROGRAMS_DATA_REQUEST = 'FETCH_ACTIVE_PROGRAMS_DATA_REQUEST';
export const GET_ACTIVE_PROGRAMS_DATA_FAILURE = 'GET_ACTIVE_PROGRAMS_DATA_FAILURE';
export const EMPTY_ACTIVE_PROGRAMS_EXPORT_DATA_UPDATE = 'EMPTY_ACTIVE_PROGRAMS_EXPORT_DATA_UPDATE';

export const AFFORDABILITY_TABLE_DATA_REQUEST = 'AFFORDABILITY_TABLE_DATA_REQUEST';
export const AFFORDABILITY_TABLE_DATA_LOADING = 'AFFORDABILITY_TABLE_DATA_LOADING';
export const AFFORDABILITY_TABLE_DATA_FAILURE = 'AFFORDABILITY_TABLE_DATA_FAILURE';
export const AFFORDABILITY_TABLE_DATA_SUCCESS = 'AFFORDABILITY_TABLE_DATA_SUCCESS';

export const SET_PROVIDER_PROFILE_DATA = 'SET_PROVIDER_PROFILE_DATA';
export const SET_CURRENT_STATE_DATA = 'SET_CURRENT_STATE_DATA';
export const SET_PNB_STRATEGY_DATA = 'SET_PNB_STRATEGY_DATA';
export const UPLOAD_TO_IMPACT_REQUEST = 'UPLOAD_TO_IMPACT_REQUEST';
export const UPLOAD_TO_IMPACT_SUCCESS = 'UPLOAD_TO_IMPACT_SUCCESS';
export const UPLOAD_TO_IMPACT_FAILURE = 'UPLOAD_TO_IMPACT_FAILURE';
export const UPLOAD_TO_IMPACT_RESET = 'UPLOAD_TO_IMPACT_RESET';
export const SET_PNB_DOC_UPDATE_TYPE = 'SET_PNB_DOC_UPDATE_TYPE';
export const ENABLE_SAVE_AND_EXIT = 'ENABLE_SAVE_AND_EXIT';
export const FETCH_PNB_HEADER_DATA = 'FETCH_PNB_HEADER_DATA';
export const FETCH_PNB_HEADER_DATA_SUCCESS = 'FETCH_PNB_HEADER_DATA_SUCCESS';
export const SET_DOCUMENT_ID = 'SET_DOCUMENT_ID';
//PaymentIntigrity Actions

export const EVALUATION_DATA_REQUEST = 'EVALUATION_DATA_REQUEST';
export const EVALUATION_DATA_LOADING = 'EVALUATION_DATA_LOADING';
export const EVALUATION_DATA_SUCCESS = 'EVALUATION_DATA_SUCCESS ';
export const EVALUATION_DATA_FAILURE = 'EVALUATION_DATA_FAILURE';

export const MEDICAL_RECORD_DATA_REQUEST = 'MEDICAL_RECORD_DATA_REQUEST';
export const MEDICAL_RECORD_DATA_LOADING = 'MEDICAL_RECORD_DATA_LOADING';
export const MEDICAL_RECORD_DATA_SUCCESS = 'MEDICAL_RECORD_DATA_SUCCESS ';
export const MEDICAL_RECORD_DATA_FAILURE = 'MEDICAL_RECORD_DATA_FAILURE ';

export const QUICKFILTER_DATA_REQUEST = 'QUICKFILTER_DATA_REQUEST';
export const QUICKFILTER_DATA_SUCCESS = 'QUICKFILTER_DATA_SUCCESS';
export const QUICKFILTER_DATA_FAILURE = 'QUICKFILTER_DATA_FAILURE';

export const EVALUATION_ADJUSTMENT_DATA_REQUEST = 'EVALUATION_ADJUSTMENT_DATA_REQUEST';
export const EVALUATION_ADJUSTMENT_DATA_LOADING = 'EVALUATION_ADJUSTMENT_DATA_LOADING';
export const EVALUATION_ADJUSTMENT_DATA_SUCCESS = 'EVALUATION_ADJUSTMENT_DATA_SUCCESS ';
export const EVALUATION_ADJUSTMENT_DATA_FAILURE = 'EVALUATION_ADJUSTMENT_DATA_FAILURE ';

export const OVERTURNS_DATA_REQUEST = 'OVERTURNS_DATA_REQUEST';
export const OVERTURNS_DATA_LOADING = 'OVERTURNS_DATA_LOADING';
export const OVERTURNS_DATA_SUCCESS = 'OVERTURNS_DATA_SUCCESS';
export const OVERTURNS_DATA_FAILURE = 'OVERTURNS_DATA_FAILURE';

export const REASON_CODE_DATA_REQUEST = 'REASON_CODE_DATA_REQUEST';
export const REASON_CODE_DATA_LOADING = 'REASON_CODE_DATA_LOADING';
export const REASON_CODE_DATA_SUCCESS = 'REASON_CODE_DATA_SUCCESS';

// PI Filters (Redux-first filter state)
export const INIT_PI_FILTERS = 'INIT_PI_FILTERS';
export const UPDATE_PI_FILTERS = 'UPDATE_PI_FILTERS';
export const RESET_PI_FILTERS = 'RESET_PI_FILTERS';
export const SET_PI_GEO_VENDOR_OPTIONS = 'SET_PI_GEO_VENDOR_OPTIONS';
export const SET_PI_PROVIDER_SIGNATURE = 'SET_PI_PROVIDER_SIGNATURE';

// Provider Experience Actions
export const APPLY_PROVIDER_EXPERIENCE_FILTER = 'APPLY_PROVIDER_EXPERIENCE_FILTER';
export const APPLY_PROVIDER_EXPERIENCE_FILTER_SUCCESS = 'APPLY_PROVIDER_EXPERIENCE_FILTER_SUCCESS';
export const PROVIDER_EXPERIENCE_IS_LOADING = 'PROVIDER_EXPERIENCE_IS_LOADING';

//common actions
export const KNOWLEDGE_CENTRE_DATA_REQUEST = 'KNOWLEDGE_CENTRE_DATA_REQUEST';
export const KNOWLEDGE_CENTRE_DATA_SUCCESS = 'KNOWLEDGE_CENTRE_DATA_SUCCESS';
export const GLOSSARY_LIST_DATA = 'GLOSSARY_LIST_DATA';

// Over Payment Graph Actions
export const OVERPAYMENT_GRAPH_DATA_REQUEST = 'OVERPAYMENT_GRAPH_DATA_REQUEST';
export const OVERPAYMENT_GRAPH_DATA_SUCCESS = 'OVERPAYMENT_GRAPH_DATA_SUCCESS';
export const OVERPAYMENT_GRAPH_DATA_FAILURE = 'OVERPAYMENT_GRAPH_DATA_FAILURE';
export const OVERPAYMENT_GRAPH_DATA_LOADING = 'OVERPAYMENT_GRAPH_DATA_LOADING';

//genaric actions
export const REQUEST_LOADING = 'REQUEST_LOADING';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const RESET_REQUEST_STATE = 'RESET_REQUEST_STATE';
export const SET_CARD_INSIGHT_METADATA = 'SET_CARD_INSIGHT_METADATA';
export const OPEN_KNOWLEDGE_CENTER = 'OPEN_KNOWLEDGE_CENTER';
export const CLOSE_KNOWLEDGE_CENTER = 'CLOSE_KNOWLEDGE_CENTER';
export const KNOWLEDGE_CENTER_STATE_KEY = 'knowledgeCenter';

//PEI Actions
export const EFFORT_INDEX_DATA_REQUEST = 'EFFORT_INDEX_DATA_REQUEST';
export const AVERAGE_CLAIMS_DATA_REQUEST = 'AVERAGE_CLAIMS_DATA_REQUEST';
export const CONRACT_YIELD_DATA_REQUEST = 'CONRACT_YIELD_DATA_REQUEST';

//PEM Actions (V2 flow - kept separate so the legacy Provider Experience saga is not triggered)
export const PEM_EFFORT_INDEX_DATA_REQUEST = 'PEM_EFFORT_INDEX_DATA_REQUEST';
export const PEM_AVERAGE_CLAIMS_DATA_REQUEST = 'PEM_AVERAGE_CLAIMS_DATA_REQUEST';
export const PEM_CONRACT_YIELD_DATA_REQUEST = 'PEM_CONRACT_YIELD_DATA_REQUEST';
export const PEM_AVG_CLAIM_TAT_TREND_DATA_REQUEST = 'PEM_AVG_CLAIM_TAT_TREND_DATA_REQUEST';
export const PEM_SERVICE_METRIC_DATA_REQUEST = 'PEM_SERVICE_METRIC_DATA_REQUEST';
export const PEM_SERVICE_METRIC_DATA_REQUEST_APPEAL = 'PEM_SERVICE_METRIC_DATA_REQUEST_APPEAL';
export const PEM_SERVICE_METRIC_DATA_REQUEST_DiGITAL = 'PEM_SERVICE_METRIC_DATA_REQUEST_DiGITAL';
export const PEM_SERVICE_METRIC_DATA_REQUEST_SECRET = 'PEM_SERVICE_METRIC_DATA_REQUEST_SECRET';

// PEM Summary Actions
export const FETCH_PEM_SUMMARY_COST_DATA_REQUEST = 'FETCH_PEM_SUMMARY_COST_DATA_REQUEST';
export const GET_PEM_SUMMARY_COST_DATA_SUCCESS = 'GET_PEM_SUMMARY_COST_DATA_SUCCESS';
export const GET_PEM_SUMMARY_COST_DATA_FAILURE = 'GET_PEM_SUMMARY_COST_DATA_FAILURE';

export const FETCH_PEM_SUMMARY_TURNAROUND_DATA_REQUEST =
  'FETCH_PEM_SUMMARY_TURNAROUND_DATA_REQUEST';
export const GET_PEM_SUMMARY_TURNAROUND_DATA_SUCCESS = 'GET_PEM_SUMMARY_TURNAROUND_DATA_SUCCESS';
export const GET_PEM_SUMMARY_TURNAROUND_DATA_FAILURE = 'GET_PEM_SUMMARY_TURNAROUND_DATA_FAILURE';

export const FETCH_PEM_SUMMARY_SERVICE_QUALITY_DATA_REQUEST =
  'FETCH_PEM_SUMMARY_SERVICE_QUALITY_DATA_REQUEST';
export const GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_SUCCESS =
  'GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_SUCCESS';
export const GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_FAILURE =
  'GET_PEM_SUMMARY_SERVICE_QUALITY_DATA_FAILURE';

//Prior Auth Actions
export const PRIORAUTH_TAX_ID_QUICKFILTER_DATA_REQUEST =
  'PRIORAUTH_TAX_ID_QUICKFILTER_DATA_REQUEST';
export const PRIORAUTH_TAX_ID_QUICKFILTER_DATA_SUCCESS =
  'PRIORAUTH_TAX_ID_QUICKFILTER_DATA_SUCCESS';
export const PRIORAUTH_TAX_ID_QUICKFILTER_DATA_FAILURE =
  'PRIORAUTH_TAX_ID_QUICKFILTER_DATA_FAILURE';

// Prior Auth Filter Management
export const SET_PRIORAUTH_FILTERS = 'SET_PRIORAUTH_FILTERS';
export const UPDATE_PRIORAUTH_FILTER = 'UPDATE_PRIORAUTH_FILTER';
export const RESET_PRIORAUTH_FILTER = 'RESET_PRIORAUTH_FILTER';
export const PRIORAUTH_FILTERS_CHANGED = 'PRIORAUTH_FILTERS_CHANGED'; // Saga trigger
export const SET_PRIORAUTH_BASE_PAYLOAD = 'SET_PRIORAUTH_BASE_PAYLOAD'; // Store base payload from saga

// Prior Auth Global Filter
export const SET_PA_TIN_COUNT = 'SET_PA_TIN_COUNT';
export const PRIORAUTH_GLOBAL_FILTERS_APPLY = 'PRIORAUTH_GLOBAL_FILTERS_APPLY';
export const PRIORAUTH_GLOBAL_FILTERS_RESET = 'PRIORAUTH_GLOBAL_FILTERS_RESET';
export const PRIORAUTH_GLOBAL_FILTERS_UPDATE = 'PRIORAUTH_GLOBAL_FILTERS_UPDATE';

export const PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_REQUEST =
  'PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_REQUEST';
export const PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_SUCCESS =
  'PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_SUCCESS';
export const PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_FAILURE =
  'PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_FAILURE';

export const PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_REQUEST =
  'PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_REQUEST';
export const PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_SUCCESS =
  'PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_SUCCESS';
export const PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_FAILURE =
  'PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_FAILURE';

export const PRIORAUTH_METRIC_DEFINITIONS_DATA_REQUEST =
  'PRIORAUTH_METRIC_DEFINITIONS_DATA_REQUEST';
export const PRIORAUTH_METRIC_DEFINITIONS_DATA_SUCCESS =
  'PRIORAUTH_METRIC_DEFINITIONS_DATA_SUCCESS';
export const PRIORAUTH_METRIC_DEFINITIONS_DATA_FAILURE =
  'PRIORAUTH_METRIC_DEFINITIONS_DATA_FAILURE';

export const CASE_SUBMISSION_DETAILS_REQUEST = 'CASE_SUBMISSION_DETAILS_REQUEST';
export const CASE_SUBMISSION_DETAILS_SUCCESS = 'CASE_SUBMISSION_DETAILS_SUCCESS';
export const CASE_SUBMISSION_DETAILS_ERROR = 'CASE_SUBMISSION_DETAILS_ERROR';
export const CASE_SUBMISSION_DETAILS_LOADING = 'CASE_SUBMISSION_DETAILS_LOADING';

export const PRIORAUTH_TURNAROUND_TIME_REQUEST = 'PRIORAUTH_TURNAROUND_TIME_REQUEST';
export const PRIORAUTH_TURNAROUND_TIME_SUCCESS = 'PRIORAUTH_TURNAROUND_TIME_SUCCESS';
export const PRIORAUTH_TURNAROUND_TIME_ERROR = 'PRIORAUTH_TURNAROUND_TIME_ERROR';
export const PRIORAUTH_TURNAROUND_TIME_LOADING = 'PRIORAUTH_TURNAROUND_TIME_LOADING';

export const INSIGHT_CARD_DATA_REQUEST = 'INSIGHT_CARD_DATA_REQUEST';
export const INSIGHT_CARD_DATA_SUCCESS = 'INSIGHT_CARD_DATA_SUCCESS';
export const INSIGHT_CARD_DATA_FAILURE = 'INSIGHT_CARD_DATA_FAILURE';
export const INSIGHT_CARD_LOADING = 'INSIGHT_CARD_LOADING';
export const CASE_SUBMISSION_CHANNELS_LOADING = 'CASE_SUBMISSION_CHANNELS_LOADING';

export const CASE_SUBMISSION_CHANNELS_DATA_REQUEST = 'CASE_SUBMISSION_CHANNELS_DATA_REQUEST';
export const CASE_SUBMISSION_CHANNELS_DATA_SUCCESS = 'CASE_SUBMISSION_CHANNELS_DATA_SUCCESS';
export const CASE_SUBMISSION_CHANNELS_DATA_FAILURE = 'CASE_SUBMISSION_CHANNELS_DATA_FAILURE';

export const CASE_SUBMISSIONS_OVER_TIME_DATA_REQUEST = 'CASE_SUBMISSIONS_OVER_TIME_DATA_REQUEST';
export const CASE_SUBMISSIONS_OVER_TIME_DATA_SUCCESS = 'CASE_SUBMISSIONS_OVER_TIME_DATA_SUCCESS';
export const CASE_SUBMISSIONS_OVER_TIME_DATA_FAILURE = 'CASE_SUBMISSIONS_OVER_TIME_DATA_FAILURE';
export const CASE_SUBMISSIONS_OVER_TIME_DATA_CANCEL = 'CASE_SUBMISSIONS_OVER_TIME_DATA_CANCEL';
export const CASE_SUBMISSIONS_OVER_TIME_LOADING = 'CASE_SUBMISSIONS_OVER_TIME_LOADING';

export const FETCH_PRIOR_AUTH_TIN_REQUEST = 'FETCH_PRIOR_AUTH_TIN_REQUEST';
export const FETCH_PRIOR_AUTH_TIN_SUCCESS = 'FETCH_PRIOR_AUTH_TIN_SUCCESS';
export const FETCH_PRIOR_AUTH_TIN_ERROR = 'FETCH_PRIOR_AUTH_TIN_ERROR';
export const FETCH_PRIOR_AUTH_TIN_LOADING = 'FETCH_PRIOR_AUTH_TIN_LOADING';

export const PRIORAUTH_NOT_APPROVED_REASONS_REQUEST = 'PRIORAUTH_NOT_APPROVED_REASONS_REQUEST';
export const PRIORAUTH_NOT_APPROVED_REASONS_SUCCESS = 'PRIORAUTH_NOT_APPROVED_REASONS_SUCCESS';
export const PRIORAUTH_NOT_APPROVED_REASONS_FAILURE = 'PRIORAUTH_NOT_APPROVED_REASONS_FAILURE';
export const PRIORAUTH_NOT_APPROVED_REASONS_LOADING = 'PRIORAUTH_NOT_APPROVED_REASONS_LOADING';

export const PRIORAUTH_CPT_CODES_REQUEST = 'PRIORAUTH_CPT_CODES_REQUEST';
export const PRIORAUTH_CPT_CODES_SUCCESS = 'PRIORAUTH_CPT_CODES_SUCCESS';
export const PRIORAUTH_CPT_CODES_FAILURE = 'PRIORAUTH_CPT_CODES_FAILURE';

// Prior Auth Polling Status
export const PRIORAUTH_POLLING_STARTED = 'PRIORAUTH_POLLING_STARTED';
export const PRIORAUTH_POLLING_COMPLETED = 'PRIORAUTH_POLLING_COMPLETED';
export const PRIORAUTH_POLLING_FAILED = 'PRIORAUTH_POLLING_FAILED';
export const PRIORAUTH_POLLING_RESET = 'PRIORAUTH_POLLING_RESET';

export const SET_TABLE_DATA = 'SET_TABLE_DATA';
export const SORT_TABLE_DATA = 'SORT_TABLE_DATA';
export const SET_DEFAULT_SORT_ORDER = 'SET_DEFAULT_SORT_ORDER';

export const SET_CURRENT_STATE_MODAL = 'SET_CURRENT_STATE_MODAL';
export const SET_CURRENT_STATE_EDITABLE = 'SET_CURRENT_STATE_EDITABLE';
export const SET_PROVIDER_PROFILE_EDITABLE = 'SET_PROVIDER_PROFILE_EDITABLE';
export const SET_PNB_STRATEGY_EDITABLE = 'SET_PNB_STRATEGY_EDITABLE';
// Global Filter Actions
export const GLOBALFILTER_DATA_REQUEST = 'GLOBALFILTER_DATA_REQUEST';
export const GLOBALFILTER_DATA_SUCCESS = 'GLOBALFILTER_DATA_SUCCESS';
export const GLOBALFILTER_DATA_FAILURE = 'GLOBALFILTER_DATA_FAILURE';

export const EVALUATION_DETAILS_DATA_REQUEST = 'EVALUATION_DETAILS_DATA_REQUEST';
export const EVALUATION_DETAILS_DATA_SUCCESS = 'EVALUATION_DETAILS_DATA_SUCCESS';
export const EVALUATION_DETAILS_DATA_FAILURE = 'EVALUATION_DETAILS_DATA_FAILURE';

export const SELECTED_RADIO_OPTIONS = 'SELECTED_RADIO_OPTIONS';
export const OVERPAYMENT_DATA_REQUEST = 'OVERPAYMENT_DATA_REQUEST';
export const OVERPAYMENT_DATA_SUCCESS = 'OVERPAYMENT_DATA_SUCCESS';
export const OVERPAYMENT_DATA_ERROR = 'OVERPAYMENT_DATA_ERROR';
export const OVERPAYMENT_DATA_LOADING = 'OVERPAYMENT_DATA_LOADING';
export const OVERPAYMENT_DATA_CANCEL = 'OVERPAYMENT_DATA_CANCEL';

// Over Payment Graph Data Actions
export const OVERPAYMENT_GRAPH_DATA_CANCEL = 'OVERPAYMENT_GRAPH_DATA_CANCEL';

// Over Payment Financial Performance Trend Graph Actions

export const OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_REQUEST =
  'OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_REQUEST';
export const OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_LOADING =
  'OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_LOADING';
export const OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_SUCCESS =
  'OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_SUCCESS';
export const OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_FAILURE =
  'OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_FAILURE';
export const OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_CANCEL =
  'OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_CANCEL';

// Over Payment Polling Actions
export const OVERPAYMENT_POLLING_STARTED = 'OVERPAYMENT_POLLING_STARTED';
export const OVERPAYMENT_POLLING_COMPLETED = 'OVERPAYMENT_POLLING_COMPLETED';
export const OVERPAYMENT_POLLING_FAILED = 'OVERPAYMENT_POLLING_FAILED';

export const OVERPAYMENT_FINANCIAL_PERFORMANCE_LOB_DATA_REQUEST =
  'OVERPAYMENT_FINANCIAL_PERFORMANCE_LOB_DATA_REQUEST';
export const OVERPAYMENT_FINANCIAL_PERFORMANCE_LOB_DATA_LOADING =
  'OVERPAYMENT_FINANCIAL_PERFORMANCE_LOB_DATA_LOADING';
export const OVERPAYMENT_FINANCIAL_PERFORMANCE_LOB_DATA_SUCCESS =
  'OVERPAYMENT_FINANCIAL_PERFORMANCE_LOB_DATA_SUCCESS';
export const OVERPAYMENT_FINANCIAL_PERFORMANCE_LOB_DATA_FAILURE =
  'OVERPAYMENT_FINANCIAL_PERFORMANCE_LOB_DATA_FAILURE';

// Reiumbursement Tabs Data Actions

export const REIUMBURSEMENT_TABS_DATA_REQUEST = 'REIUMBURSEMENT_TABS_DATA_REQUEST';
export const REIUMBURSEMENT_TABS_DATA_LOADING = 'REIUMBURSEMENT_TABS_DATA_LOADING';
export const REIUMBURSEMENT_TABS_DATA_SUCCESS = 'REIUMBURSEMENT_TABS_DATA_SUCCESS';
export const REIUMBURSEMENT_TABS_DATA_FAILURE = 'REIUMBURSEMENT_TABS_DATA_FAILURE';

export const REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_REQUEST =
  'REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_REQUEST';
export const REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_SUCCESS =
  'REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_SUCCESS';
export const REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_FAILURE =
  'REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_FAILURE';
export const REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_LOADING =
  'REIUMBURSEMENT_TABS_DATA_DOP_FILTERS_LOADING';

export const REIUMBURSEMENT_TABS_NONPAYMENT_REQUEST = 'REIUMBURSEMENT_TABS_NONPAYMENT_REQUEST';
export const REIUMBURSEMENT_TABS_NONPAYMENT_SUCCESS = 'REIUMBURSEMENT_TABS_NONPAYMENT_SUCCESS';
export const REIUMBURSEMENT_TABS_NONPAYMENT_FAILURE = 'REIUMBURSEMENT_TABS_NONPAYMENT_FAILURE';
export const REIUMBURSEMENT_TABS_NONPAYMENT_LOADING = 'REIUMBURSEMENT_TABS_NONPAYMENT_LOADING';

export const REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_REQUEST =
  'REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_REQUEST';
export const REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_SUCCESS =
  'REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_SUCCESS';
export const REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_FAILURE =
  'REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_FAILURE';
export const REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_LOADING =
  'REIUMBURSEMENT_APPEALS_TAB_DETAILS_DATA_LOADING';

export const REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_REQUEST =
  'REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_REQUEST';
export const REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_SUCCESS =
  'REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_SUCCESS';
export const REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_FAILURE =
  'REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_FAILURE';
export const REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_LOADING =
  'REIUMBURSEMENT_RECONSIDERATION_TAB_DETAILS_DATA_LOADING';
export const REIUMBURSEMENT_TABS_POLLING_STARTED = 'REIUMBURSEMENT_TABS_POLLING_STARTED';
export const REIUMBURSEMENT_TABS_POLLING_COMPLETED = 'REIUMBURSEMENT_TABS_POLLING_COMPLETED';
export const REIUMBURSEMENT_TABS_POLLING_FAILED = 'REIUMBURSEMENT_TABS_POLLING_FAILED';
export const REIUMBURSEMENT_TABS_POLLING_RESET = 'REIUMBURSEMENT_TABS_POLLING_RESET';

// Service Metrics Actions
export const SERVICE_METRIC_DATA_REQUEST = 'SERVICE_METRIC_DATA_REQUEST';
export const SERVICE_METRIC_DATA_REQUEST_APPEAL = 'SERVICE_METRIC_DATA_REQUEST_APPEAL';
export const SERVICE_METRIC_DATA_REQUEST_DiGITAL = 'SERVICE_METRIC_DATA_REQUEST_DiGITAL';
export const SERVICE_METRIC_DATA_REQUEST_SECRET = 'SERVICE_METRIC_DATA_REQUEST_SECRET';

// Hi Volume Tins Actions

export const FETCH_TINS_DETAILS_REQUEST = 'FETCH_TINS_DETAILS_REQUEST';
export const FETCH_TINS_DETAILS_SUCCESS = 'FETCH_TINS_DETAILS_SUCCESS';
export const FETCH_TINS_DETAILS_FAILURE = 'FETCH_TINS_DETAILS_FAILURE';
export const SAVE_CUSTOM_LIST_REQUEST = 'SAVE_CUSTOM_LIST_REQUEST';
export const SAVE_CUSTOM_LIST_SUCCESS = 'SAVE_CUSTOM_LIST_SUCCESS';
export const SAVE_CUSTOM_LIST_FAILURE = 'SAVE_CUSTOM_LIST_FAILURE';
export const RESET_TINS_DETAILS = 'RESET_TINS_DETAILS';
export const SET_FILTER_LIST_SEARCH = 'SET_FILTER_LIST_SEARCH';
export const REENTER_TINS = 'REENTER_TINS';
export const UPDATE_LIST_NAME = 'UPDATE_LIST_NAME';
export const SET_ADD_MORE_TINS_SEARCH = 'SET_ADD_MORE_TINS_SEARCH';
export const ADD_SINGLE_TIN_TO_LIST_REQUEST = 'ADD_SINGLE_TIN_TO_LIST_REQUEST';
export const ADD_SINGLE_TIN_TO_LIST_SUCCESS = 'ADD_SINGLE_TIN_TO_LIST_SUCCESS';
export const ADD_SINGLE_TIN_TO_LIST_FAILURE = 'ADD_SINGLE_TIN_TO_LIST_FAILURE';
export const ADD_MORE_TINS_DATA_REQUEST = 'ADD_MORE_TINS_DATA_REQUEST';
export const ADD_MORE_TINS_DATA_SUCCESS = 'ADD_MORE_TINS_DATA_SUCCESS';
export const ADD_MORE_TINS_DATA_FAILURE = 'ADD_MORE_TINS_DATA_FAILURE';

// Payment Integrity Details action types
export const PAYMENT_INTEGRITY_DETAILS_REQUEST = 'PAYMENT_INTEGRITY_DETAILS_REQUEST';
export const PAYMENT_INTEGRITY_DETAILS_SUCCESS = 'PAYMENT_INTEGRITY_DETAILS_SUCCESS';
export const PAYMENT_INTEGRITY_DETAILS_FAILURE = 'PAYMENT_INTEGRITY_DETAILS_FAILURE';
export const PAYMENT_INTEGRITY_DETAILS_LOADING = 'PAYMENT_INTEGRITY_DETAILS_LOADING';
// Appeal Actions
export const APPEAL_DATA_REQUEST = 'APPEAL_DATA_REQUEST';
export const APPEAL_DATA_SUCCESS = 'APPEAL_DATA_SUCCESS';
export const APPEAL_DATA_FAILURE = 'APPEAL_DATA_FAILURE';

export const APPEAL_DETAILS_DATA_REQUEST = 'APPEAL_DETAILS_DATA_REQUEST';
export const APPEAL_DETAILS_DATA_CANCEL = 'APPEAL_DETAILS_DATA_CANCEL';

export const UPDATE_TIN_SELECTION = 'UPDATE_TIN_SELECTION';
// Geo Top Filter Actions
export const APPEALS_TOP_OVERTURN_REASON_DATA_REQUEST = 'APPEALS_TOP_OVERTURN_REASON_DATA_REQUEST';
export const APPEALS_TOP_OVERTURN_REASON_DATA_SUCCESS = 'APPEALS_TOP_OVERTURN_REASON_DATA_SUCCESS';
export const APPEALS_TOP_OVERTURN_REASON_DATA_LOADING = 'APPEALS_TOP_OVERTURN_REASON_DATA_LOADING';
export const APPEALS_TOP_OVERTURN_REASON_DATA_FAILURE = 'APPEALS_TOP_OVERTURN_REASON_DATA_FAILURE';
export const APPEALS_TOP_OVERTURN_REASON_DATA_CANCEL = 'APPEALS_TOP_OVERTURN_REASON_DATA_CANCEL';
export const SET_APPEAL_STATUS_FILTER = 'SET_APPEAL_STATUS_FILTER';

// Geo Top Filter Actions
export const GEO_TOP_FILTER_REQUEST = 'GEO_TOP_FILTER_REQUEST';
export const GEO_EXEMPTION_EXCLUSION_REQUEST = 'GEO_EXEMPTION_EXCLUSION_REQUEST';

export const RECONSIDERATION_PENDING_BY_VOLUME_REQUEST =
  'RECONSIDERATION_PENDING_BY_VOLUME_REQUEST';
export const RECONSIDERATION_PENDING_BY_VOLUME_SUCCESS =
  'RECONSIDERATION_PENDING_BY_VOLUME_SUCCESS';
export const RECONSIDERATION_PENDING_BY_VOLUME_FAILURE =
  'RECONSIDERATION_PENDING_BY_VOLUME_FAILURE';
export const RECONSIDERATION_PENDING_BY_VOLUME_LOADING =
  'RECONSIDERATION_PENDING_BY_VOLUME_LOADING';

export const RECONSIDERATION_AVERAGE_TURNAROUND_TIME_REQUEST =
  'RECONSIDERATION_AVERAGE_TURNAROUND_TIME_REQUEST';
export const RECONSIDERATION_AVERAGE_TURNAROUND_TIME_SUCCESS =
  'RECONSIDERATION_AVERAGE_TURNAROUND_TIME_SUCCESS';
export const RECONSIDERATION_AVERAGE_TURNAROUND_TIME_FAILURE =
  'RECONSIDERATION_AVERAGE_TURNAROUND_TIME_FAILURE';
export const RECONSIDERATION_AVERAGE_TURNAROUND_TIME_LOADING =
  'RECONSIDERATION_AVERAGE_TURNAROUND_TIME_LOADING';

export const RECONSIDERATION_OUTCOME_VOLUME_DATA_REQUEST =
  'RECONSIDERATION_OUTCOME_VOLUME_DATA_REQUEST';
export const RECONSIDERATION_OUTCOME_VOLUME_DATA_SUCCESS =
  'RECONSIDERATION_OUTCOME_VOLUME_DATA_SUCCESS';
export const RECONSIDERATION_OUTCOME_VOLUME_DATA_FAILURE =
  'RECONSIDERATION_OUTCOME_VOLUME_DATA_FAILURE';

export const RECONSIDERATION_OUTCOME_SUBMISSION_DATA_REQUEST =
  'RECONSIDERATION_OUTCOME_SUBMISSION_DATA_REQUEST';
export const RECONSIDERATION_OUTCOME_SUBMISSION_DATA_SUCCESS =
  'RECONSIDERATION_OUTCOME_SUBMISSION_DATA_SUCCESS';
export const RECONSIDERATION_OUTCOME_SUBMISSION_DATA_FAILURE =
  'RECONSIDERATION_OUTCOME_SUBMISSION_DATA_FAILURE';

export const RECONSIDERATION_DETAILS_REQUEST = 'RECONSIDERATION_DETAILS_REQUEST';
export const RECONSIDERATION_DETAILS_SUCCESS = 'RECONSIDERATION_DETAILS_SUCCESS';
export const RECONSIDERATION_DETAILS_FAILURE = 'RECONSIDERATION_DETAILS_FAILURE';
export const RECONSIDERATIONS_DETAILS_DATA_REQUEST = 'RECONSIDERATIONS_DETAILS_DATA_REQUEST';

export const APPEALS_TREND_DATA_REQUEST = 'APPEALS_TREND_DATA_REQUEST';
export const APPEALS_TREND_DATA_SUCCESS = 'APPEALS_TREND_DATA_SUCCESS';
export const APPEALS_TREND_DATA_FAILURE = 'APPEALS_TREND_DATA_FAILURE';
export const APPEALS_TREND_DATA_LOADING = 'APPEALS_TREND_DATA_LOADING';
export const APPEALS_TREND_DATA_CANCEL = 'APPEALS_TREND_DATA_CANCEL';

export const NONPAYMENT_DETAILS_DATA_REQUEST = 'NONPAYMENT_DETAILS_DATA_REQUEST';
export const NONPAYMENT_DETAILS_DATA_SUCCESS = 'NONPAYMENT_DETAILS_DATA_SUCCESS';
export const NONPAYMENT_DETAILS_DATA_FAILURE = 'NONPAYMENT_DETAILS_DATA_FAILURE';
export const NONPAYMENT_DETAILS_DATA_LOADING = 'NONPAYMENT_DETAILS_DATA_LOADING';

export const NONPAYMENT_TOP_REASON_DATA_REQUEST = 'NONPAYMENT_TOP_REASON_DATA_REQUEST';
export const NONPAYMENT_TOP_REASON_DATA_LOADING = 'NONPAYMENT_TOP_REASON_DATA_LOADING';
export const NONPAYMENT_TOP_REASON_DATA_SUCCESS = 'NONPAYMENT_TOP_REASON_DATA_SUCCESS';
export const NONPAYMENT_TOP_REASON_DATA_FAILURE = 'NONPAYMENT_TOP_REASON_DATA_FAILURE';

export const NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_REQUEST =
  'NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_REQUEST';
export const NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_LOADING =
  'NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_LOADING';
export const NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_SUCCESS =
  'NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_SUCCESS';
export const NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_FAILURE =
  'NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_FAILURE';

export const NONPAYMENT_CLAIMS_TREND_LOB_DATA_REQUEST = 'NONPAYMENT_CLAIMS_TREND_LOB_DATA_REQUEST';
export const NONPAYMENT_CLAIMS_TREND_LOB_DATA_LOADING = 'NONPAYMENT_CLAIMS_TREND_LOB_DATA_LOADING';
export const NONPAYMENT_CLAIMS_TREND_LOB_DATA_SUCCESS = 'NONPAYMENT_CLAIMS_TREND_LOB_DATA_SUCCESS';
export const NONPAYMENT_CLAIMS_TREND_LOB_DATA_FAILURE = 'NONPAYMENT_CLAIMS_TREND_LOB_DATA_FAILURE';

export const NONPAYMENT_COMPLETE_AND_TREND_DATA_REQUEST =
  'NONPAYMENT_COMPLETE_AND_TREND_DATA_REQUEST';
export const NONPAYMENT_COMPLETE_AND_TREND_DATA_LOADING =
  'NONPAYMENT_COMPLETE_AND_TREND_DATA_LOADING';
export const NONPAYMENT_COMPLETE_AND_TREND_DATA_SUCCESS =
  'NONPAYMENT_COMPLETE_AND_TREND_DATA_SUCCESS';
export const NONPAYMENT_COMPLETE_AND_TREND_DATA_FAILURE =
  'NONPAYMENT_COMPLETE_AND_TREND_DATA_FAILURE';

export const PAYMENTS_CLAIMS_PAID_REQUEST = 'PAYMENTS_CLAIMS_PAID_REQUEST';
export const PAYMENTS_CLAIMS_PAID_SUCCESS = 'PAYMENTS_CLAIMS_PAID_SUCCESS';
export const PAYMENTS_CLAIMS_PAID_FAILURE = 'PAYMENTS_CLAIMS_PAID_FAILURE';
export const PAYMENTS_CLAIMS_PAID_LOADING = 'PAYMENTS_CLAIMS_PAID_LOADING';

export const PAYMENTS_CLAIMS_DOP_REQUEST = 'PAYMENTS_CLAIMS_DOP_REQUEST';
export const PAYMENTS_CLAIMS_DOP_SUCCESS = 'PAYMENTS_CLAIMS_DOP_SUCCESS';
export const PAYMENTS_CLAIMS_DOP_FAILURE = 'PAYMENTS_CLAIMS_DOP_FAILURE';
export const PAYMENTS_CLAIMS_DOP_LOADING = 'PAYMENTS_CLAIMS_DOP_LOADING';

export const PAYMENTS_POLLING_COMPLETED = 'PAYMENTS_POLLING_COMPLETED';
export const PAYMENTS_POLLING_STARTED = 'PAYMENTS_POLLING_STARTED';
export const PAYMENTS_POLLING_FAILED = 'PAYMENTS_POLLING_FAILED';
export const PAYMENTS_POLLING_RESET = 'PAYMENTS_POLLING_RESET';

export const PAYMENTS_CLAIMS_DOP_CANCEL = 'PAYMENTS_CLAIMS_DOP_CANCEL';
export const PAYMENTS_CLAIMSBIFURCATE_CANCEL = 'PAYMENTS_CLAIMSBIFURCATE_CANCEL';
export const PAYMENTS_CLAIMSPAID_CANCEL = 'PAYMENTS_CLAIMSPAID_CANCEL';
export const PAYMENTS_CLAIMSSUMMARY_CANCEL = 'PAYMENTS_CLAIMSSUMMARY_CANCEL';
export const PAYMENTS_CLAIMSYIELD_CANCEL = 'PAYMENTS_CLAIMSYIELD_CANCEL';
export const PAYMENTS_CLAIMS_SERVICE_PASS_CANCEL = 'PAYMENTS_CLAIMS_SERVICE_PASS_CANCEL';

export const CLAIMS_BIFURCATE_METRICS_REQUEST = 'CLAIMS_BIFURCATE_METRICS_REQUEST';
export const CLAIMS_BIFURCATE_METRICS_SUCCESS = 'CLAIMS_BIFURCATE_METRICS_SUCCESS';
export const CLAIMS_BIFURCATE_METRICS_FAILURE = 'CLAIMS_BIFURCATE_METRICS_FAILURE';
export const CLAIMS_BIFURCATE_METRICS_LOADING = 'CLAIMS_BIFURCATE_METRICS_LOADING';

export const PAYMENTS_CLAIMS_SUMMARY_REQUEST = 'PAYMENTS_CLAIMS_SUMMARY_REQUEST';
export const PAYMENTS_CLAIMS_SUMMARY_SUCCESS = 'PAYMENTS_CLAIMS_SUMMARY_SUCCESS';
export const PAYMENTS_CLAIMS_SUMMARY_FAILURE = 'PAYMENTS_CLAIMS_SUMMARY_FAILURE';
export const PAYMENTS_CLAIMS_SUMMARY_LOADING = 'PAYMENTS_CLAIMS_SUMMARY_LOADING';

export const CLAIMS_YIELD_ALL_PASSES_METRICS_REQUEST = 'CLAIMS_YIELD_ALL_PASSES_METRICS_REQUEST';
export const CLAIMS_YIELD_ALL_PASSES_METRICS_SUCCESS = 'CLAIMS_YIELD_ALL_PASSES_METRICS_SUCCESS';
export const CLAIMS_YIELD_ALL_PASSES_METRICS_FAILURE = 'CLAIMS_YIELD_ALL_PASSES_METRICS_FAILURE';
export const CLAIMS_YIELD_ALL_PASSES_METRICS_LOADING = 'CLAIMS_YIELD_ALL_PASSES_METRICS_LOADING';
export const SERVICE_TYPE_PASS_WISE_METRICS_REQUEST = 'SERVICE_TYPE_PASS_WISE_METRICS_REQUEST';
export const SERVICE_TYPE_PASS_WISE_METRICS_SUCCESS = 'SERVICE_TYPE_PASS_WISE_METRICS_SUCCESS';
export const SERVICE_TYPE_PASS_WISE_METRICS_FAILURE = 'SERVICE_TYPE_PASS_WISE_METRICS_FAILURE';
export const SERVICE_TYPE_PASS_WISE_METRICS_LOADING = 'SERVICE_TYPE_PASS_WISE_METRICS_LOADING';
export const REMOVE_TEMP_DATA = 'REMOVE_TEMP_DATA';

export const SUREST_FILTER_DATA_REQUEST = 'SUREST_FILTER_DATA_REQUEST';
export const SUREST_FILTER_DATA_SUCCESS = 'SUREST_FILTER_DATA_SUCCESS';
export const SUREST_FILTER_DATA_FAILURE = 'SUREST_FILTER_DATA_FAILURE';
export const SUREST_FILTER_DATA_LOADING = 'SUREST_FILTER_DATA_LOADING';

export const GET_TOTAL_TINS_SUCCESS = 'GET_TOTAL_TINS_SUCCESS';
export const GET_TOTAL_TINS_FAILURE = 'GET_TOTAL_TINS_FAILURE';
export const GET_TOTAL_TINS_REQUEST = 'GET_TOTAL_TINS_REQUEST';

export const CLAIMS_PROCESSED_REQUEST = 'CLAIMS_PROCESSED_REQUEST';
export const CLAIMS_PROCESSED_SUCCESS = 'CLAIMS_PROCESSED_SUCCESS';
export const CLAIMS_PROCESSED_FAILURE = 'CLAIMS_PROCESSED_FAILURE';
export const CLAIMS_PROCESSED_LOADING = 'CLAIMS_PROCESSED_LOADING';

export const CLAIMS_METRICS_EXCLUSION_REQUEST = 'CLAIMS_METRICS_EXCLUSION_REQUEST';
export const CLAIMS_METRICS_EXCLUSION_SUCCESS = 'CLAIMS_METRICS_EXCLUSION_SUCCESS';
export const CLAIMS_METRICS_EXCLUSION_FAILURE = 'CLAIMS_METRICS_EXCLUSION_FAILURE';
export const CLAIMS_METRICS_EXCLUSION_LOADING = 'CLAIMS_METRICS_EXCLUSION_LOADING';

export const DOP_CLAIMS_METRICS_CLAIMS_REQUEST = 'DOP_CLAIMS_METRICS_CLAIMS_REQUEST';
export const DOP_CLAIMS_METRICS_CLAIMS_LOADING = 'DOP_CLAIMS_METRICS_CLAIMS_LOADING';
export const DOP_CLAIMS_METRICS_CLAIMS_SUCCESS = 'DOP_CLAIMS_METRICS_CLAIMS_SUCCESS';
export const DOP_CLAIMS_METRICS_CLAIMS_FAILURE = 'DOP_CLAIMS_METRICS_CLAIMS_FAILURE';

export const DOP_CLAIMS_METRICS_TAT_REQUEST = 'DOP_CLAIMS_METRICS_TAT_REQUEST';
export const DOP_CLAIMS_METRICS_TAT_LOADING = 'DOP_CLAIMS_METRICS_TAT_LOADING';
export const DOP_CLAIMS_METRICS_TAT_SUCCESS = 'DOP_CLAIMS_METRICS_TAT_SUCCESS';

export const CLAIMS_PROCESSED_MONTHLY_REQUEST = 'CLAIMS_PROCESSED_MONTHLY_REQUEST';
export const CLAIMS_PROCESSED_MONTHLY_SUCCESS = 'CLAIMS_PROCESSED_MONTHLY_SUCCESS';
export const CLAIMS_PROCESSED_MONTHLY_FAILURE = 'CLAIMS_PROCESSED_MONTHLY_FAILURE';
export const CLAIMS_PROCESSED_MONTHLY_LOADING = 'CLAIMS_PROCESSED_MONTHLY_LOADING';

export const CLAIMS_PROCESSED_LOB_REQUEST = 'CLAIMS_PROCESSED_LOB_REQUEST';
export const CLAIMS_PROCESSED_LOB_SUCCESS = 'CLAIMS_PROCESSED_LOB_SUCCESS';
export const CLAIMS_PROCESSED_LOB_FAILURE = 'CLAIMS_PROCESSED_LOB_FAILURE';
export const CLAIMS_PROCESSED_LOB_LOADING = 'CLAIMS_PROCESSED_LOB_LOADING';

export const DOP_CLAIMS_METRICS_TAT_FAILURE = 'DOP_CLAIMS_METRICS_TAT_FAILURE';

export const SUREST_RELATIVE_COST_DRIVERS_REQUEST = 'SUREST_RELATIVE_COST_DRIVERS_REQUEST';
export const SUREST_RELATIVE_COST_DRIVERS_SUCCESS = 'SUREST_RELATIVE_COST_DRIVERS_SUCCESS';
export const SUREST_RELATIVE_COST_DRIVERS_FAILURE = 'SUREST_RELATIVE_COST_DRIVERS_FAILURE';
export const SUREST_RELATIVE_COST_DRIVERS_LOADING = 'SUREST_RELATIVE_COST_DRIVERS_LOADING';

export const SUREST_RELATIVE_DISTRIBUTION_SUCCESS = 'SUREST_RELATIVE_DISTRIBUTION_SUCCESS';
export const SUREST_RELATIVE_DISTRIBUTION_REQUEST = 'SUREST_RELATIVE_DISTRIBUTION_REQUEST';
export const SUREST_RELATIVE_DISTRIBUTION_FAILURE = 'SUREST_RELATIVE_DISTRIBUTION_FAILURE';
export const SUREST_RELATIVE_COMMON_SERVICES_REQUEST = 'SUREST_RELATIVE_COMMON_SERVICES_REQUEST';
export const SUREST_RELATIVE_COMMON_SERVICES_SUCCESS = 'SUREST_RELATIVE_COMMON_SERVICES_SUCCESS';
export const SUREST_RELATIVE_COMMON_SERVICES_FAILURE = 'SUREST_RELATIVE_COMMON_SERVICES_FAILURE';

export const PCOR_DATA_REQUEST = 'PCOR_DATA_REQUEST';
export const PCOR_DATA_SUCCESS = 'PCOR_DATA_SUCCESS';
export const PCOR_DATA_FAILURE = 'PCOR_DATA_FAILURE';
export const PCOR_DATA_LOADING = 'PCOR_DATA_LOADING';

export const PCOR_FILTER_REQUEST = 'PCOR_FILTER_REQUEST';
export const PCOR_FILTER_SUCCESS = 'PCOR_FILTER_SUCCESS';
export const PCOR_FILTER_FAILURE = 'PCOR_FILTER_FAILURE';
export const PCOR_FILTER_LOADING = 'PCOR_FILTER_LOADING';

export const SMART_EDITS_SUMMARY_REQUEST = 'SMART_EDITS_SUMMARY_REQUEST';
export const SMART_EDITS_SUMMARY_SUCCESS = 'SMART_EDITS_SUMMARY_SUCCESS';
export const SMART_EDITS_SUMMARY_FAILURE = 'SMART_EDITS_SUMMARY_FAILURE';
export const SMART_EDITS_SUMMARY_LOADING = 'SMART_EDITS_SUMMARY_LOADING';

export const SMART_EDIT_STATUS_REQUEST = 'SMART_EDIT_STATUS_REQUEST';
export const SMART_EDIT_STATUS_SUCCESS = 'SMART_EDIT_STATUS_SUCCESS';
export const SMART_EDIT_STATUS_FAILURE = 'SMART_EDIT_STATUS_FAILURE';
export const SMART_EDIT_STATUS_LOADING = 'SMART_EDIT_STATUS_LOADING';

export const SMART_EDIT_TOP_REASONS_REQUEST = 'SMART_EDIT_TOP_REASONS_REQUEST';
export const SMART_EDIT_TOP_REASONS_SUCCESS = 'SMART_EDIT_TOP_REASONS_SUCCESS';
export const SMART_EDIT_TOP_REASONS_FAILURE = 'SMART_EDIT_TOP_REASONS_FAILURE';
export const SMART_EDIT_TOP_REASONS_LOADING = 'SMART_EDIT_TOP_REASONS_LOADING';

export const SMART_EDIT_TOP_CLAIM_REQUEST = 'SMART_EDIT_TOP_CLAIM_REQUEST';
export const SMART_EDIT_TOP_CLAIM_SUCCESS = 'SMART_EDIT_TOP_CLAIM_SUCCESS';
export const SMART_EDIT_TOP_CLAIM_FAILURE = 'SMART_EDIT_TOP_CLAIM_FAILURE';
export const SMART_EDIT_TOP_CLAIM_LOADING = 'SMART_EDIT_TOP_CLAIM_LOADING';

export const SMART_EDIT_GEO_FILTER_MARKET_DATA_REQUEST =
  'SMART_EDIT_GEO_FILTER_MARKET_DATA_REQUEST';
export const SMART_EDIT_GEO_FILTER_MARKET_DATA_SUCCESS =
  'SMART_EDIT_GEO_FILTER_MARKET_DATA_SUCCESS';
export const SMART_EDIT_GEO_FILTER_MARKET_DATA_FAILURE =
  'SMART_EDIT_GEO_FILTER_MARKET_DATA_FAILURE';
export const SMART_EDIT_GEO_FILTER_MARKET_DATA_LOADING =
  'SMART_EDIT_GEO_FILTER_MARKET_DATA_LOADING';

export const SMART_EDIT_GEO_FILTER_STATE_DATA_REQUEST = 'SMART_EDIT_GEO_FILTER_STATE_DATA_REQUEST';
export const SMART_EDIT_GEO_FILTER_STATE_DATA_SUCCESS = 'SMART_EDIT_GEO_FILTER_STATE_DATA_SUCCESS';
export const SMART_EDIT_GEO_FILTER_STATE_DATA_FAILURE = 'SMART_EDIT_GEO_FILTER_STATE_DATA_FAILURE';
export const SMART_EDIT_GEO_FILTER_STATE_DATA_LOADING = 'SMART_EDIT_GEO_FILTER_STATE_DATA_LOADING';

export const SUREST_RELATIVE_GRAPH_DATA_REQUEST = 'SUREST_RELATIVE_GRAPH_DATA_REQUEST';
export const SUREST_RELATIVE_GRAPH_DATA_SUCCESS = 'SUREST_RELATIVE_GRAPH_DATA_SUCCESS';
export const SUREST_RELATIVE_GRAPH_DATA_FAILURE = 'SUREST_RELATIVE_GRAPH_DATA_FAILURE';
export const SUREST_RELATIVE_GRAPH_DATA_LOADING = 'SUREST_RELATIVE_GRAPH_DATA_LOADING';
export const SUREST_RESET = 'SUREST_RESET';
// Notification Banner Manager Actions
export const FETCH_NOTIFICATION_BANNERS_REQUEST = 'FETCH_NOTIFICATION_BANNERS_REQUEST';
export const FETCH_NOTIFICATION_BANNERS_SUCCESS = 'FETCH_NOTIFICATION_BANNERS_SUCCESS';
export const FETCH_NOTIFICATION_BANNERS_FAILURE = 'FETCH_NOTIFICATION_BANNERS_FAILURE';

export const SET_NOTIFICATION_BANNER_LOADING = 'SET_NOTIFICATION_BANNER_LOADING';
export const CLEAR_NOTIFICATION_BANNER_ERROR = 'CLEAR_NOTIFICATION_BANNER_ERROR';

// Site notifications action types
export const FETCH_SITE_NOTIFICATIONS_REQUEST = 'FETCH_SITE_NOTIFICATIONS_REQUEST';
export const FETCH_SITE_NOTIFICATIONS_SUCCESS = 'FETCH_SITE_NOTIFICATIONS_SUCCESS';
export const FETCH_SITE_NOTIFICATIONS_FAILURE = 'FETCH_SITE_NOTIFICATIONS_FAILURE';
export const FETCH_SITE_NOTIFICATIONS_LOADING = 'FETCH_SITE_NOTIFICATIONS_LOADING';

// Save site notification action types
export const SAVE_SITE_NOTIFICATION_REQUEST = 'SAVE_SITE_NOTIFICATION_REQUEST';
export const SAVE_SITE_NOTIFICATION_SUCCESS = 'SAVE_SITE_NOTIFICATION_SUCCESS';
export const SAVE_SITE_NOTIFICATION_FAILURE = 'SAVE_SITE_NOTIFICATION_FAILURE';

// ANCILLARY FILTER ACTION TYPES
export const ANCILLARY_FILTER_DATA_REQUEST = 'ANCILLARY_FILTER_DATA_REQUEST';
export const ANCILLARY_FILTER_DATA_SUCCESS = 'ANCILLARY_FILTER_DATA_SUCCESS';
export const ANCILLARY_FILTER_DATA_FAILURE = 'ANCILLARY_FILTER_DATA_FAILURE';
export const ANCILLARY_FILTER_DATA_LOADING = 'ANCILLARY_FILTER_DATA_LOADING';

export const ANCILLARY_CAT_DETAILS_DATA_REQUEST = 'ANCILLARY_CAT_DETAILS_DATA_REQUEST';
export const ANCILLARY_CAT_DETAILS_DATA_SUCCESS = 'ANCILLARY_CAT_DETAILS_DATA_SUCCESS';
export const ANCILLARY_CAT_DETAILS_DATA_FAILURE = 'ANCILLARY_CAT_DETAILS_DATA_FAILURE';
export const ANCILLARY_CAT_DETAILS_DATA_LOADING = 'ANCILLARY_CAT_DETAILS_DATA_LOADING';

export const ANCILLARY_NET_CAT_DETAILS_DATA_REQUEST = 'ANCILLARY_NET_CAT_DETAILS_DATA_REQUEST';
export const ANCILLARY_NET_CAT_DETAILS_DATA_SUCCESS = 'ANCILLARY_NET_CAT_DETAILS_DATA_SUCCESS';
export const ANCILLARY_NET_CAT_DETAILS_DATA_FAILURE = 'ANCILLARY_NET_CAT_DETAILS_DATA_FAILURE';
export const ANCILLARY_NET_CAT_DETAILS_DATA_LOADING = 'ANCILLARY_NET_CAT_DETAILS_DATA_LOADING';

export const ANCILLARY_CATEGORY_VIEW_DATA_REQUEST = 'ANCILLARY_CATEGORY_VIEW_DATA_REQUEST';
export const ANCILLARY_CATEGORY_VIEW_DATA_SUCCESS = 'ANCILLARY_CATEGORY_VIEW_DATA_SUCCESS';
export const ANCILLARY_CATEGORY_VIEW_DATA_FAILURE = 'ANCILLARY_CATEGORY_VIEW_DATA_FAILURE';
export const ANCILLARY_CATEGORY_VIEW_DATA_LOADING = 'ANCILLARY_CATEGORY_VIEW_DATA_LOADING';

export const ANCILLARY_EXPORT_LINK_REQUEST = 'ANCILLARY_EXPORT_LINK_REQUEST';
export const ANCILLARY_EXPORT_LINK_SUCCESS = 'ANCILLARY_EXPORT_LINK_SUCCESS';
export const ANCILLARY_EXPORT_LINK_FAILURE = 'ANCILLARY_EXPORT_LINK_FAILURE';
export const ANCILLARY_EXPORT_LINK_LOADING = 'ANCILLARY_EXPORT_LINK_LOADING';

export const IMAGING_DETAILS_DATA_REQUEST = 'IMAGING_DETAILS_DATA_REQUEST';
export const IMAGING_DETAILS_DATA_SUCCESS = 'IMAGING_DETAILS_DATA_SUCCESS';
export const IMAGING_DETAILS_DATA_FAILURE = 'IMAGING_DETAILS_DATA_FAILURE';
export const IMAGING_DETAILS_DATA_LOADING = 'IMAGING_DETAILS_DATA_LOADING';

export const IMAGING_FILTER_DATA_REQUEST = 'IMAGING_FILTER_DATA_REQUEST';
export const IMAGING_FILTER_DATA_SUCCESS = 'IMAGING_FILTER_DATA_SUCCESS';
export const IMAGING_FILTER_DATA_FAILURE = 'IMAGING_FILTER_DATA_FAILURE';
export const IMAGING_FILTER_DATA_LOADING = 'IMAGING_FILTER_DATA_LOADING';

export const IMAGING_CAT_DETAILS_DATA_REQUEST = 'IMAGING_CAT_DETAILS_DATA_REQUEST';
export const IMAGING_CAT_DETAILS_DATA_SUCCESS = 'IMAGING_CAT_DETAILS_DATA_SUCCESS';
export const IMAGING_CAT_DETAILS_DATA_FAILURE = 'IMAGING_CAT_DETAILS_DATA_FAILURE';
export const IMAGING_CAT_DETAILS_DATA_LOADING = 'IMAGING_CAT_DETAILS_DATA_LOADING';

export const IMAGING_NET_CAT_DETAILS_DATA_REQUEST = 'IMAGING_NET_CAT_DETAILS_DATA_REQUEST';
export const IMAGING_NET_CAT_DETAILS_DATA_SUCCESS = 'IMAGING_NET_CAT_DETAILS_DATA_SUCCESS';
export const IMAGING_NET_CAT_DETAILS_DATA_FAILURE = 'IMAGING_NET_CAT_DETAILS_DATA_FAILURE';
export const IMAGING_NET_CAT_DETAILS_DATA_LOADING = 'IMAGING_NET_CAT_DETAILS_DATA_LOADING';

export const IMAGING_EXPORT_LINK_SUCCESS = 'IMAGING_EXPORT_LINK_SUCCESS';
export const IMAGING_EXPORT_LINK_REQUEST = 'IMAGING_EXPORT_LINK_REQUEST';
export const IMAGING_EXPORT_LINK_FAILURE = 'IMAGING_EXPORT_LINK_FAILURE';
export const IMAGING_EXPORT_LINK_LOADING = 'IMAGING_EXPORT_LINK_LOADING';

export const IMAGING_CATEGORY_VIEW_DATA_REQUEST = 'IMAGING_CATEGORY_VIEW_DATA_REQUEST';
export const IMAGING_CATEGORY_VIEW_DATA_SUCCESS = 'IMAGING_CATEGORY_VIEW_DATA_SUCCESS';
export const IMAGING_CATEGORY_VIEW_DATA_FAILURE = 'IMAGING_CATEGORY_VIEW_DATA_FAILURE';
export const IMAGING_CATEGORY_VIEW_DATA_LOADING = 'IMAGING_CATEGORY_VIEW_DATA_LOADING';

export const SUMMARY_DATA_REQUEST = 'SUMMARY_DATA_REQUEST';
export const SUMMARY_DATA_LOADING = 'SUMMARY_DATA_LOADING';
export const SUMMARY_DATA_SUCCESS = 'SUMMARY_DATA_SUCCESS';
export const SUMMARY_DATA_ERROR = 'SUMMARY_DATA_ERROR';
export const CALLSPAGE_QUICKFILTER_DATA_REQUEST = 'CALLSPAGE_QUICKFILTER_DATA_REQUEST';
export const CALLSPAGE_QUICKFILTER_DATA_SUCCESS = 'CALLSPAGE_QUICKFILTER_DATA_SUCCESS';
export const CALLTYPE_DATA_REQUEST = 'CALLTYPE_DATA_REQUEST';
export const CALLTYPE_DATA_ERROR = 'CALLTYPE_DATA_ERROR';
export const CALLTYPE_DATA_LOADING = 'CALLTYPE_DATA_LOADING';
export const CALLTYPE_DATA_SUCCESS = 'CALLTYPE_DATA_SUCCESS';
export const CALLMONTH_DATA_LOADING = 'CALLMONTH_DATA_LOADING';
export const CALLMONTH_DATA_SUCCESS = 'CALLMONTH_DATA_SUCCESS';
export const CALLMONTH_DATA_REQUEST = 'CALLMONTH_DATA_REQUEST';
export const CALLS_GEO_TIN_COUNT_DATA_REQUEST = 'CALLS_GEO_TIN_COUNT_DATA_REQUEST';
export const CALLS_GEO_TIN_COUNT_DATA_SUCCESS = 'CALLS_GEO_TIN_COUNT_DATA_SUCCESS';
export const CALLS_GEO_TIN_COUNT_DATA_LOADING = 'CALLS_GEO_TIN_COUNT_DATA_LOADING';

export const CALLS_PAGE_POLLING_STARTED = 'CALLS_PAGE_POLLING_STARTED';
export const CALLS_PAGE_POLLING_COMPLETED = 'CALLS_PAGE_POLLING_COMPLETED';
export const CALLS_PAGE_POLLING_FAILED = 'CALLS_PAGE_POLLING_FAILED';
export const CALLS_PAGE_POLLING_RESET = 'CALLS_PAGE_POLLING_RESET';

export const CALLS_SUMMARY_DETAILS_CANCEL = 'CALLS_SUMMARY_DETAILS_CANCEL';
export const CALLS_CALLTYPE_DETAILS_CANCEL = 'CALLS_CALLTYPE_DETAILS_CANCEL';
export const CALLS_CALLMONTH_DETAILS_CANCEL = 'CALLS_CALLMONTH_DETAILS_CANCEL';

// Consolidated filter action for Angular-React sync
export const SET_ALL_FILTERS = 'SET_ALL_FILTERS';

export const FETCH_ONBOARDING_DATA_REQUEST = 'FETCH_ONBOARDING_DATA_REQUEST';
export const FETCH_ONBOARDING_DATA_SUCCESS = 'FETCH_ONBOARDING_DATA_SUCCESS';
export const FETCH_ONBOARDING_DATA_FAILURE = 'FETCH_ONBOARDING_DATA_FAILURE';
export const FETCH_ONBOARDING_DATA_LOADING = 'FETCH_ONBOARDING_DATA_LOADING';

//save ONBOArding list
export const SAVE_ONBOARDING_DATA_REQUEST = 'SAVE_ONBOARDING_DATA_REQUEST';
export const SAVE_ONBOARDING_DATA_SUCCESS = 'SAVE_ONBOARDING_DATA_SUCCESS';
export const SAVE_ONBOARDING_DATA_FAILURE = 'SAVE_ONBOARDING_DATA_FAILURE';
export const SAVE_ONBOARDING_DATA_LOADING = 'SAVE_ONBOARDING_DATA_LOADING';
//get ONBOArding images
export const ON_BOARDING_IMAGES_REQUEST = 'ON_BOARDING_IMAGES_REQUEST';
export const ON_BOARDING_IMAGES_SUCCESS = 'ON_BOARDING_IMAGES_SUCCESS';
export const ON_BOARDING_IMAGES_FAILURE = 'ON_BOARDING_IMAGES_FAILURE';
export const ON_BOARDING_IMAGES_LOADING = 'ON_BOARDING_IMAGES_LOADING';

//unpublish onboarding
export const UNPUBLISH_ONBOARDING_REQUEST = 'UNPUBLISH_ONBOARDING_REQUEST';
export const UNPUBLISH_ONBOARDING_SUCCESS = 'UNPUBLISH_ONBOARDING_SUCCESS';
export const UNPUBLISH_ONBOARDING_FAILURE = 'UNPUBLISH_ONBOARDING_FAILURE';
export const UNPUBLISH_ONBOARDING_LOADING = 'UNPUBLISH_ONBOARDING_LOADING';

//Settlement Actions
export const SETTLEMENT_SELECTED_RADIO_OPTIONS = 'SETTLEMENT_SELECTED_RADIO_OPTIONS';
export const SETTLEMENT_DATA_REQUEST = 'SETTLEMENT_DATA_REQUEST';
export const OVERVIEW_DATA_REQUEST_SUCCESS = 'OVERVIEW_DATA_REQUEST_SUCCESS';
export const OVERVIEW_DATA_ERROR = 'OVERVIEW_DATA_ERROR';
export const SETTLEMENT_DATA_LOADING = 'SETTLEMENT_DATA_LOADING';
export const OVERVIEW_DATA_REQUEST = 'OVERVIEW_DATA_REQUEST';
export const OVERVIEW_DATA_LOADING = 'OVERVIEW_DATA_LOADING';
export const SETTLEMENT_TINFILTER_DATA_REQUEST = 'SETTLEMENT_TINFILTER_DATA_REQUEST';
export const SETTLEMENT_TINFILTER_DATA_LOADING = 'SETTLEMENT_TINFILTER_DATA_LOADING';
export const SETTLEMENT_TINFILTER_DATA_SUCCESS = 'SETTLEMENT_TINFILTER_DATA_SUCCESS';
export const FILTER_TIME_PERIOD_SUCCESS = 'FILTER_TIME_PERIOD_SUCCESS';
export const FILTER_LOB_SUCCESS = 'FILTER_LOB_SUCCESS';
export const FILTER_TAXID_SUCCESS = 'FILTER_TAXID_SUCCESS';

// Prior Auth Submission Actions
export const PRIOR_AUTH_SUBMISSION_DATA_REQUEST = 'PRIOR_AUTH_SUBMISSION_DATA_REQUEST';

// Prior Auth Insights Actions
export const PRIOR_AUTH_INSIGHTS_DATA_REQUEST = 'PRIOR_AUTH_INSIGHTS_DATA_REQUEST';

// Service Interactions Actions
export const SERVICE_INTERACTIONS_CALLS_DATA_REQUEST = 'SERVICE_INTERACTIONS_CALLS_DATA_REQUEST';
export const SERVICE_INTERACTIONS_SMART_EDITS_DATA_REQUEST =
  'SERVICE_INTERACTIONS_SMART_EDITS_DATA_REQUEST';

//pcms
export const PCMS_DATA_REQUEST = 'PCMS_DATA_REQUEST';

//poca
export const POCA_DATA_REQUEST = 'POCA_DATA_REQUEST';
export const SETTLEMENT_VOLUME_DATA_REQUEST = 'SETTLEMENT_VOLUME_DATA_REQUEST';
export const SETTLEMENT_PAYMENT_DATA_REQUEST = 'SETTLEMENT_PAYMENT_DATA_REQUEST';
export const SETTLEMENT_PAYMENT_DATA_SUCCESS = 'SETTLEMENT_PAYMENT_DATA_SUCCESS';
export const SETTLEMENT_PAYMENT_DATA_LOADING = 'SETTLEMENT_PAYMENT_DATA_LOADING';
export const SETTLEMENT_CURRENT_FLOW = 'SETTLEMENT_CURRENT_FLOW';
export const SETTLEMENT_TREND_DATA_REQUEST = 'SETTLEMENT_TREND_DATA_REQUEST';
export const SETTLEMENT_TREND_PAYMENT_DATA_SUCCESS = 'SETTLEMENT_TREND_PAYMENT_DATA_SUCCESS';
export const SETTLEMENT_TREND_VOLUME_DATA_SUCCESS = 'SETTLEMENT_TREND_VOLUME_DATA_SUCCESS';
export const SETTLEMENT_VOLUME_DATA_SUCCESS = 'SETTLEMENT_VOLUME_DATA_SUCCESS';
export const SETTLEMENT_VOLUME_DATA_LOADING = 'SETTLEMENT_VOLUME_DATA_LOADING';
export const SETTLEMENT_TREND_MEDICAID_REQUEST = 'SETTLEMENT_TREND_MEDICAID_REQUEST';
export const SETTLEMENT_TREND_MEDICARE_REQUEST = 'SETTLEMENT_TREND_MEDICARE_REQUEST';
export const SETTLEMENT_TREND_UNCATERGORIZED_REQUEST = 'SETTLEMENT_TREND_UNCATERGORIZED_REQUEST';
export const SETTLEMENT_TREND_COMMERCIAL_REQUEST = 'SETTLEMENT_TREND_COMMERCIAL_REQUEST';
export const SETTLEMENT_TREND_DATA_LOADING = 'SETTLEMENT_TREND_DATA_LOADING';
export const SETTLEMENT_TREND_MEDICAID_SUCCESS = 'SETTLEMENT_TREND_MEDICAID_SUCCESS';
export const SETTLEMENT_TREND_MEDICARE_SUCCESS = 'SETTLEMENT_TREND_MEDICARE_SUCCESS';
export const SETTLEMENT_TREND_UNCATERGORIZED_SUCCESS = 'SETTLEMENT_TREND_UNCATERGORIZED_SUCCESS';
export const SETTLEMENT_TREND_COMMERCIAL_SUCCESS = 'SETTLEMENT_TREND_COMMERCIAL_SUCCESS';
export const SETTLEMENT_TREND_SUCCESS = 'SETTLEMENT_TREND_SUCCESS';
export const SETTLEMENT_MEDICARE_DATA_LOADING = 'SETTLEMENT_MEDICARE_DATA_LOADING';
export const SETTLEMENT_MEDICAID_DATA_LOADING = 'SETTLEMENT_MEDICAID_DATA_LOADING';
export const SETTLEMENT_COMMERCIAL_DATA_LOADING = 'SETTLEMENT_COMMERCIAL_DATA_LOADING';
export const SETTLEMENT_UNCATEGORIZED_DATA_LOADING = 'SETTLEMENT_UNCATEGORIZED_DATA_LOADING';
export const SETTLEMENT_GEOFILTER_DATA_REQUEST = 'SETTLEMENT_GEOFILTER_DATA_REQUEST';
export const SETTLEMENT_GEOFILTER_DATA_SUCCESS = 'SETTLEMENT_GEOFILTER_DATA_SUCCESS';
export const SETTLEMENT_EMPTY_DATA = 'SETTLEMENT_EMPTY_DATA';
export const SETTLEMENT_RESET_STATE = 'SETTLEMENT_RESET_STATE';
export const SETTLEMENT_RESET_DATA = 'SETTLEMENT_RESET_DATA';
export const START_END_DATE_SUCCESS = 'START_END_DATE_SUCCESS';
// VBC Filters Actions
export const VBC_FILTER_TIME_PERIOD_UPDATE = 'VBC_FILTER_TIME_PERIOD_UPDATE';
export const VBC_FILTER_LOB_UPDATE = 'VBC_FILTER_LOB_UPDATE';
export const VBC_FILTER_TAXIDS_UPDATE = 'VBC_FILTER_TAXIDS_UPDATE';
export const VBC_TAXIDS_REQUEST = 'VBC_TAXIDS_REQUEST';
export const VBC_TAXIDS_LOADING = 'VBC_TAXIDS_LOADING';
export const VBC_TAXIDS_SUCCESS = 'VBC_TAXIDS_SUCCESS';
export const VBC_TAXIDS_FAILURE = 'VBC_TAXIDS_FAILURE';

// VBC Geo Segmentation Filters Actions
export const VBC_GEOFILTER_REGION = 'VBC_GEOFILTER_REGION';
export const VBC_GEOFILTER_STATE = 'VBC_GEOFILTER_STATE';
export const VBC_GEOFILTER_MARKET = 'VBC_GEOFILTER_MARKET';

// VBC Payouts Actions
export const GET_PAYOUTS_DATA_SUCCESS = 'GET_PAYOUTS_DATA_SUCCESS';
export const FETCH_PAYOUTS_DATA_REQUEST = 'FETCH_PAYOUTS_DATA_REQUEST';
export const GET_PAYOUTS_DATA_FAILURE = 'GET_PAYOUTS_DATA_FAILURE';

// VBC Inflators Actions
export const GET_INFLATORS_DATA_SUCCESS = 'GET_INFLATORS_DATA_SUCCESS';
export const FETCH_INFLATORS_DATA_REQUEST = 'FETCH_INFLATORS_DATA_REQUEST';
export const GET_INFLATORS_DATA_FAILURE = 'GET_INFLATORS_DATA_FAILURE';

export const SETTLEMENT_GEOFILTER_REGION = 'SETTLEMENT_GEOFILTER_REGION';
export const SETTLEMENT_GEOFILTER_STATE = 'SETTLEMENT_GEOFILTER_STATE';
export const SETTLEMENT_GEOFILTER_MARKET = 'SETTLEMENT_GEOFILTER_MARKET';
export const GEO_MARKET_HOME_VAL_CHECK = 'GEO_MARKET_HOME_VAL_CHECK';
export const GEO_STATE_HOME_VAL_CHECK = 'GEO_STATE_HOME_VAL_CHECK';
//PRECHECK MYSCRIPT ACTIONS
export const PCMS_AMDSM_REQUEST = 'PCMS_AMDSM_REQUEST';
export const PCMS_AMDSM_SUCCESS = 'PCMS_AMDSM_SUCCESS';
export const PCMS_AMDSM_FAILURE = 'PCMS_AMDSM_FAILURE';
export const PCMS_AMDSM_LOADING = 'PCMS_AMDSM_LOADING';

export const PCMS_SOT_REQUEST = 'PCMS_SOT_REQUEST';
export const PCMS_SOT_SUCCESS = 'PCMS_SOT_SUCCESS';
export const PCMS_SOT_FAILURE = 'PCMS_SOT_FAILURE';
export const PCMS_SOT_LOADING = 'PCMS_SOT_LOADING';

export const PCMS_CARE_ASSIST_REQUEST = 'PCMS_CARE_ASSIST_REQUEST';
export const PCMS_CARE_ASSIST_SUCCESS = 'PCMS_CARE_ASSIST_SUCCESS';
export const PCMS_CARE_ASSIST_FAILURE = 'PCMS_CARE_ASSIST_FAILURE';
export const PCMS_CARE_ASSIST_LOADING = 'PCMS_CARE_ASSIST_LOADING';

export const PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_REQUEST =
  'PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_REQUEST';
export const PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_SUCCESS =
  'PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_SUCCESS';
export const PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_FAILURE =
  'PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_FAILURE';
export const PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_LOADING =
  'PCMS_CARE_ASSIST_TIN_ACTIVATIONS_DETAILS_LOADING';
export const PCMS_DETAILS_REQUEST = 'PCMS_DETAILS_REQUEST';
export const PCMS_DETAILS_SUCCESS = 'PCMS_DETAILS_SUCCESS';
export const PCMS_DETAILS_FAILURE = 'PCMS_DETAILS_FAILURE';
export const PCMS_DETAILS_LOADING = 'PCMS_DETAILS_LOADING';

// PCMS Filter Actions
export const PCMS_FILTER_DATA_REQUEST = 'PCMS_FILTER_DATA_REQUEST';
export const PCMS_FILTER_DATA_SUCCESS = 'PCMS_FILTER_DATA_SUCCESS';
export const PCMS_FILTER_DATA_FAILURE = 'PCMS_FILTER_DATA_FAILURE';
export const PCMS_FILTER_DATA_LOADING = 'PCMS_FILTER_DATA_LOADING';

//SETTLEMENTS DETAILS ACTIONS
export const SETTLEMENT_DETAILS_DATA_REQUEST = 'SETTLEMENT_DETAILS_DATA_REQUEST';
export const SETTLEMENT_DETAILS_DATA_LOADING = 'SETTLEMENT_DETAILS_DATA_LOADING';
export const SETTLEMENT_DETAILS_DATA_SUCCESS = 'SETTLEMENT_DETAILS_DATA_SUCCESS';
export const SETTLEMENT_DETAILS_DATA_FAILURE = 'SETTLEMENT_DETAILS_DATA_FAILURE';

//Generic Filter Actions
export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const SET_LOCATION = 'SET_LOCATION';
export const SET_CATEGORY = 'SET_CATEGORY';

// EDI filter actions
export const EDI_FILTER_NPI_DATA_REQUEST = 'EDI_FILTER_NPI_DATA_REQUEST';
export const EDI_FILTER_NPI_DATA_LOADING = 'EDI_FILTER_NPI_DATA_LOADING';
export const EDI_FILTER_NPI_DATA_SUCCESS = 'EDI_FILTER_NPI_DATA_SUCCESS';
export const EDI_FILTER_NPI_DATA_FAILURE = 'EDI_FILTER_NPI_DATA_FAILURE';

export const EDI_FILTER_STATE_DATA_REQUEST = 'EDI_FILTER_STATE_DATA_REQUEST';
export const EDI_FILTER_STATE_DATA_LOADING = 'EDI_FILTER_STATE_DATA_LOADING';
export const EDI_FILTER_STATE_DATA_SUCCESS = 'EDI_FILTER_STATE_DATA_SUCCESS';
export const EDI_FILTER_STATE_DATA_FAILURE = 'EDI_FILTER_STATE_DATA_FAILURE';

export const EDI_FILTER_MARKET_DATA_REQUEST = 'EDI_FILTER_MARKET_DATA_REQUEST';
export const EDI_FILTER_MARKET_DATA_LOADING = 'EDI_FILTER_MARKET_DATA_LOADING';
export const EDI_FILTER_MARKET_DATA_SUCCESS = 'EDI_FILTER_MARKET_DATA_SUCCESS';
export const EDI_FILTER_MARKET_DATA_FAILURE = 'EDI_FILTER_MARKET_DATA_FAILURE';

export const EDI_FILTER_TIN_DATA_REQUEST = 'EDI_FILTER_TIN_DATA_REQUEST';
export const EDI_FILTER_TIN_DATA_LOADING = 'EDI_FILTER_TIN_DATA_LOADING';
export const EDI_FILTER_TIN_DATA_SUCCESS = 'EDI_FILTER_TIN_DATA_SUCCESS';
export const EDI_FILTER_TIN_DATA_FAILURE = 'EDI_FILTER_TIN_DATA_FAILURE';
// Add these new action types
export const PRIORAUTH_CPT_APPROVALS_REQUEST = 'PRIORAUTH_CPT_APPROVALS_REQUEST';
export const PRIORAUTH_CPT_APPROVALS_SUCCESS = 'PRIORAUTH_CPT_APPROVALS_SUCCESS';
export const PRIORAUTH_CPT_APPROVALS_FAILURE = 'PRIORAUTH_CPT_APPROVALS_FAILURE';
export const SET_PRIORAUTH_CPT_APPROVALS_LOADING = 'SET_PRIORAUTH_CPT_APPROVALS_LOADING';

// FAQ Actions
export const FETCH_FAQ_LIST_DATA_REQUEST = 'FETCH_FAQ_LIST_DATA_REQUEST';
export const FETCH_FAQ_LIST_DATA_SUCCESS = 'FETCH_FAQ_LIST_DATA_SUCCESS';
export const FETCH_FAQ_LIST_DATA_FAILURE = 'FETCH_FAQ_LIST_DATA_FAILURE';
export const FETCH_FAQ_LIST_DATA_LOADING = 'FETCH_FAQ_LIST_DATA_LOADING';

export const FETCH_FAQ_CATEGORIES_REQUEST = 'FETCH_FAQ_CATEGORIES_REQUEST';
export const FETCH_FAQ_CATEGORIES_SUCCESS = 'FETCH_FAQ_CATEGORIES_SUCCESS';
export const FETCH_FAQ_CATEGORIES_FAILURE = 'FETCH_FAQ_CATEGORIES_FAILURE';
export const FETCH_FAQ_CATEGORIES_LOADING = 'FETCH_FAQ_CATEGORIES_LOADING';

export const SAVE_FAQ_FORM_REQUEST = 'SAVE_FAQ_FORM_REQUEST';
export const SAVE_FAQ_FORM_SUCCESS = 'SAVE_FAQ_FORM_SUCCESS';
export const SAVE_FAQ_FORM_FAILURE = 'SAVE_FAQ_FORM_FAILURE';
export const SAVE_FAQ_FORM_LOADING = 'SAVE_FAQ_FORM_LOADING';

export const DELETE_FAQ_REQUEST = 'DELETE_FAQ_REQUEST';
export const DELETE_FAQ_SUCCESS = 'DELETE_FAQ_SUCCESS';
export const DELETE_FAQ_FAILURE = 'DELETE_FAQ_FAILURE';
export const DELETE_FAQ_LOADING = 'DELETE_FAQ_LOADING';
export const SET_IS_FAQ_DELETED = 'SET_IS_FAQ_DELETED';

export const UPDATE_FAQ_FORM_FIELD = 'UPDATE_FAQ_FORM_FIELD';
export const UPDATE_FAQ_FORM_ERRORS = 'UPDATE_FAQ_FORM_ERRORS';

export const SET_FAQ_EDIT_DATA_REQUEST = 'SET_FAQ_EDIT_DATA_REQUEST';
export const SET_FAQ_EDIT_DATA_SUCCESS = 'SET_FAQ_EDIT_DATA_SUCCESS';
export const SET_FAQ_EDIT_DATA_FAILURE = 'SET_FAQ_EDIT_DATA_FAILURE';
export const SET_FAQ_EDIT_DATA_LOADING = 'SET_FAQ_EDIT_DATA_LOADING';

export const SET_FAQ_FORM_STATE = 'SET_FAQ_FORM_STATE';
export const SET_IS_FAQ_FORM_SAVED = 'SET_IS_FAQ_FORM_SAVED';
export const SET_FAQ_FORM_SAVED_ERROR = 'SET_FAQ_FORM_SAVED_ERROR';
export const RESET_FAQ_FORM = 'RESET_FAQ_FORM';

export const EXPORT_FAQ_DATA_REQUEST = 'EXPORT_FAQ_DATA_REQUEST';
export const EXPORT_FAQ_DATA_SUCCESS = 'EXPORT_FAQ_DATA_SUCCESS';
export const EXPORT_FAQ_DATA_FAILURE = 'EXPORT_FAQ_DATA_FAILURE';
export const EXPORT_FAQ_DATA_LOADING = 'EXPORT_FAQ_DATA_LOADING';

// PSMS payment Integrity Actions
export const PSMS_PAYMENT_INTEGRITY_DATA_REQUEST = 'PSMS_PAYMENT_INTEGRITY_DATA_REQUEST';
export const PSMS_PAYMENT_INTEGRITY_DATA_SUCCESS = 'PSMS_PAYMENT_INTEGRITY_DATA_SUCCESS';
export const PSMS_PAYMENT_INTEGRITY_DATA_FAILURE = 'PSMS_PAYMENT_INTEGRITY_DATA_FAILURE';
export const PSMS_PAYMENT_INTEGRITY_DATA_LOADING = 'PSMS_PAYMENT_INTEGRITY_DATA_LOADING';

export const PSMS_EVAlUATION_DETAILS_DATA_REQUEST = 'PSMS_EVAlUATION_DETAILS_DATA_REQUEST';
export const PSMS_EVAlUATION_DETAILS_DATA_SUCCESS = 'PSMS_EVAlUATION_DETAILS_DATA_SUCCESS';
export const PSMS_EVAlUATION_DETAILS_DATA_FAILURE = 'PSMS_EVAlUATION_DETAILS_DATA_FAILURE';
export const PSMS_EVAlUATION_DETAILS_DATA_LOADING = 'PSMS_EVAlUATION_DETAILS_DATA_LOADING';

export const PSMS_AUDIT_REASON_CODE_DATA_REQUEST = 'PSMS_AUDIT_REASON_CODE_DATA_REQUEST';
export const PSMS_AUDIT_REASON_CODE_DATA_SUCCESS = 'PSMS_AUDIT_REASON_CODE_DATA_SUCCESS';
export const PSMS_AUDIT_REASON_CODE_DATA_FAILURE = 'PSMS_AUDIT_REASON_CODE_DATA_FAILURE';
export const PSMS_AUDIT_REASON_CODE_DATA_LOADING = 'PSMS_AUDIT_REASON_CODE_DATA_LOADING';

//Digital Adoption actions
export const PSMS_DIGITAL_SOLUTION_SUMMARY_REQUEST = 'PSMS_DIGITAL_SOLUTION_SUMMARY_REQUEST';
export const PSMS_DIGITAL_SOLUTION_SUMMARY_SUCCESS = 'PSMS_DIGITAL_SOLUTION_SUMMARY_SUCCESS';
export const PSMS_DIGITAL_SOLUTION_SUMMARY_FAILURE = 'PSMS_DIGITAL_SOLUTION_SUMMARY_FAILURE';
export const PSMS_DIGITAL_SOLUTION_SUMMARY_LOADING = 'PSMS_DIGITAL_SOLUTION_SUMMARY_LOADING';

export const PSMS_DS_ADOPTIONRATE_REQUEST = 'PSMS_DS_ADOPTIONRATE_REQUEST';
export const PSMS_DS_ADOPTIONRATE_SUCCESS = 'PSMS_DS_ADOPTIONRATE_SUCCESS';
export const PSMS_DS_ADOPTIONRATE_FAILURE = 'PSMS_DS_ADOPTIONRATE_FAILURE';
export const PSMS_DS_ADOPTIONRATE_LOADING = 'PSMS_DS_ADOPTIONRATE_LOADING';

// PSMS Filter Actions
export const PSMS_FETCH_CLAIMS_SUCCESS = 'PSMS_FETCH_CLAIMS_SUCCESS';
export const PSMS_FETCH_CLAIMS_FAILURE = 'PSMS_FETCH_CLAIMS_FAILURE';
export const PSMS_FETCH_CLAIMS_REQUEST = 'PSMS_FETCH_CLAIMS_REQUEST';
export const PSMS_FETCH_CLAIMS_LOADING = 'PSMS_FETCH_CLAIMS_LOADING';

// PSMS MCR Inventory Actions
export const PSMS_MCR_INVENTORY_REQUEST = 'PSMS_MCR_INVENTORY_REQUEST';
export const PSMS_MCR_INVENTORY_SUCCESS = 'PSMS_MCR_INVENTORY_SUCCESS';
export const PSMS_MCR_INVENTORY_FAILURE = 'PSMS_MCR_INVENTORY_FAILURE';
export const PSMS_MCR_INVENTORY_LOADING = 'PSMS_MCR_INVENTORY_LOADING';

// PSMS MCR Evaluation Details Actions
export const PSMS_MCR_EVALUATION_DETAILS_REQUEST = 'PSMS_MCR_EVALUATION_DETAILS_REQUEST';
export const PSMS_MCR_EVALUATION_DETAILS_SUCCESS = 'PSMS_MCR_EVALUATION_DETAILS_SUCCESS';
export const PSMS_MCR_EVALUATION_DETAILS_FAILURE = 'PSMS_MCR_EVALUATION_DETAILS_FAILURE';
export const PSMS_MCR_EVALUATION_DETAILS_LOADING = 'PSMS_MCR_EVALUATION_DETAILS_LOADING';

export const PSMS_CALLS_CHATS_DETAILS_REQUEST = 'PSMS_CALLS_CHATS_DETAILS_REQUEST';
export const PSMS_CALLS_CHATS_DETAILS_SUCCESS = 'PSMS_CALLS_CHATS_DETAILS_SUCCESS';
export const PSMS_CALLS_CHATS_DETAILS_FAILURE = 'PSMS_CALLS_CHATS_DETAILS_FAILURE';
export const PSMS_CALLS_CHATS_DETAILS_LOADING = 'PSMS_CALLS_CHATS_DETAILS_LOADING';

export const PSMS_CALLS_CHATS_TREND_REQUEST = 'PSMS_CALLS_CHATS_TREND_REQUEST';
export const PSMS_CALLS_CHATS_TREND_SUCCESS = 'PSMS_CALLS_CHATS_TREND_SUCCESS';
export const PSMS_CALLS_CHATS_TREND_FAILURE = 'PSMS_CALLS_CHATS_TREND_FAILURE';
export const PSMS_CALLS_CHATS_TREND_LOADING = 'PSMS_CALLS_CHATS_TREND_LOADING';

export const PSMS_CLAIMS_SUMMARY_REQUEST = 'PSMS_CLAIMS_SUMMARY_REQUEST';
export const PSMS_CLAIMS_SUMMARY_SUCCESS = 'PSMS_CLAIMS_SUMMARY_SUCCESS';
export const PSMS_CLAIMS_SUMMARY_FAILURE = 'PSMS_CLAIMS_SUMMARY_FAILURE';
export const PSMS_CLAIMS_SUMMARY_LOADING = 'PSMS_CLAIMS_SUMMARY_LOADING';

export const PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST =
  'PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST';
export const PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_SUCCESS =
  'PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_SUCCESS';
export const PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_FAILURE =
  'PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_FAILURE';
export const PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_LOADING =
  'PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_LOADING';

export const PSMS_INIT = 'PSMS_INIT';
export const SET_PSMS_FILTERS = 'SET_PSMS_FILTERS';
export const UPDATE_PSMS_FILTER = 'UPDATE_PSMS_FILTER';
export const RESET_PSMS_FILTER = 'RESET_PSMS_FILTER';
export const PSMS_FILTERS_CHANGED = 'PSMS_FILTERS_CHANGED';
export const SET_PSMS_BASE_PAYLOAD = 'SET_PSMS_BASE_PAYLOAD';

// PSMS CLAIMS ACTIONS
export const PSMSCLAIMS_APPEALS_TREND_DATA_REQUEST = 'PSMSCLAIMS_APPEALS_TREND_DATA_REQUEST';
export const PSMSCLAIMS_APPEALS_TREND_DATA_SUCCESS = 'PSMSCLAIMS_APPEALS_TREND_DATA_SUCCESS';
export const PSMSCLAIMS_APPEALS_TREND_DATA_FAILURE = 'PSMSCLAIMS_APPEALS_TREND_DATA_FAILURE';
export const PSMSCLAIMS_APPEALS_TREND_DATA_LOADING = 'PSMSCLAIMS_APPEALS_TREND_DATA_LOADING';
export const PSMSCLAIMS_TOPREASONS_DATA_REQUEST = 'PSMSCLAIMS_TOPREASONS_DATA_REQUEST';
export const PSMSCLAIMS_TOPREASONS_DATA_SUCCESS = 'PSMSCLAIMS_TOPREASONS_DATA_SUCCESS';
export const PSMSCLAIMS_TOPREASONS_DATA_FAILURE = 'PSMSCLAIMS_TOPREASONS_DATA_FAILURE';
export const PSMSCLAIMS_TOPREASONS_DATA_LOADING = 'PSMSCLAIMS_TOPREASONS_DATA_LOADING';
export const PSMSCLAIMS_TOPREASONS_HEADER_DATA_REQUEST =
  'PSMSCLAIMS_TOPREASONS_HEADER_DATA_REQUEST';
export const PSMSCLAIMS_TOPREASONS_HEADER_DATA_LOADING =
  'PSMSCLAIMS_TOPREASONS_HEADER_DATA_LOADING';
export const PSMSCLAIMS_TOPREASONS_HEADER_DATA_SUCCESS =
  'PSMSCLAIMS_TOPREASONS_HEADER_DATA_SUCCESS';
export const PSMSCLAIMS_TOPREASONS_HEADER_DATA_ERROR = 'PSMSCLAIMS_TOPREASONS_HEADER_DATA_ERROR';

export const PSMSCLAIMS_CLAIMS_TREND_DATA_REQUEST = 'PSMSCLAIMS_CLAIMS_TREND_DATA_REQUEST';
export const PSMSCLAIMS_CLAIMS_TREND_DATA_LOADING = 'PSMSCLAIMS_CLAIMS_TREND_DATA_LOADING';
export const PSMSCLAIMS_CLAIMS_TREND_DATA_SUCCESS = 'PSMSCLAIMS_CLAIMS_TREND_DATA_SUCCESS';
export const PSMSCLAIMS_CLAIMS_TREND_DATA_FAILURE = 'PSMSCLAIMS_CLAIMS_TREND_DATA_FAILURE';
export const PSMSCLAIMS_RECON_DATA_LOADING = 'PSMSCLAIMS_RECON_DATA_LOADING';
export const PSMSCLAIMS_RECON_DATA_SUCCESS = 'PSMSCLAIMS_RECON_DATA_SUCCESS';
export const PSMSCLAIMS_RECON_DATA_REQUEST = 'PSMSCLAIMS_RECON_DATA_REQUEST';
export const PSMSCLAIMS_RECON_DATA_FAILURE = 'PSMSCLAIMS_RECON_DATA_FAILURE';

// PSMS CLAIMS - OUTCOME VOLUME ACTIONS
export const PSMSCLAIMS_OUTCOME_REASONS_REQUEST = 'PSMSCLAIMS_OUTCOME_REASONS_REQUEST';
export const PSMSCLAIMS_OUTCOME_REASONS_SUCCESS = 'PSMSCLAIMS_OUTCOME_REASONS_SUCCESS';
export const PSMSCLAIMS_OUTCOME_REASONS_FAILURE = 'PSMSCLAIMS_OUTCOME_REASONS_FAILURE';
export const PSMSCLAIMS_OUTCOME_REASONS_LOADING = 'PSMSCLAIMS_OUTCOME_REASONS_LOADING';

export const PSMSCLAIMS_SUBMISSION_REASONS_REQUEST = 'PSMSCLAIMS_SUBMISSION_REASONS_REQUEST';
export const PSMSCLAIMS_SUBMISSION_REASONS_SUCCESS = 'PSMSCLAIMS_SUBMISSION_REASONS_SUCCESS';
export const PSMSCLAIMS_SUBMISSION_REASONS_FAILURE = 'PSMSCLAIMS_SUBMISSION_REASONS_FAILURE';
export const PSMSCLAIMS_SUBMISSION_REASONS_LOADING = 'PSMSCLAIMS_SUBMISSION_REASONS_LOADING';

export const PSMSCLAIMS_RECON_DETAILS_REQUEST = 'PSMSCLAIMS_RECON_DETAILS_REQUEST';
export const PSMSCLAIMS_RECON_DETAILS_SUCCESS = 'PSMSCLAIMS_RECON_DETAILS_SUCCESS';
export const PSMSCLAIMS_RECON_DETAILS_FAILURE = 'PSMSCLAIMS_RECON_DETAILS_FAILURE';
export const PSMSCLAIMS_RECON_DETAILS_LOADING = 'PSMSCLAIMS_RECON_DETAILS_LOADING';

// PSMS View Tax ID Details
export const PSMS_TAXID_HEALTH_SYSTEM_REQUEST = 'PSMS_TAXID_HEALTH_SYSTEM_REQUEST';
export const PSMS_TAXID_HEALTH_SYSTEM_SUCCESS = 'PSMS_TAXID_HEALTH_SYSTEM_SUCCESS';
export const PSMS_TAXID_HEALTH_SYSTEM_FAILURE = 'PSMS_TAXID_HEALTH_SYSTEM_FAILURE';
export const PSMS_TAXID_HEALTH_SYSTEM_LOADING = 'PSMS_TAXID_HEALTH_SYSTEM_LOADING';

export const PSMS_TAXID_EXTENDED_TIN_REQUEST = 'PSMS_TAXID_EXTENDED_TIN_REQUEST';
export const PSMS_TAXID_EXTENDED_TIN_SUCCESS = 'PSMS_TAXID_EXTENDED_TIN_SUCCESS';
export const PSMS_TAXID_EXTENDED_TIN_FAILURE = 'PSMS_TAXID_EXTENDED_TIN_FAILURE';
export const PSMS_TAXID_EXTENDED_TIN_LOADING = 'PSMS_TAXID_EXTENDED_TIN_LOADING';

// PSMS Accounts Receivable - Recovery Rates Trend
export const PSMS_RECOVERY_RATES_TREND_REQUEST = 'PSMS_RECOVERY_RATES_TREND_REQUEST';
export const PSMS_RECOVERY_RATES_TREND_SUCCESS = 'PSMS_RECOVERY_RATES_TREND_SUCCESS';
export const PSMS_RECOVERY_RATES_TREND_FAILURE = 'PSMS_RECOVERY_RATES_TREND_FAILURE';
export const PSMS_RECOVERY_RATES_TREND_LOADING = 'PSMS_RECOVERY_RATES_TREND_LOADING';

// PSMS Settlements Details Actions
export const PSMS_SETTLEMENTS_DETAILS_REQUEST = 'PSMS_SETTLEMENTS_DETAILS_REQUEST';
export const PSMS_SETTLEMENTS_DETAILS_SUCCESS = 'PSMS_SETTLEMENTS_DETAILS_SUCCESS';
export const PSMS_SETTLEMENTS_DETAILS_FAILURE = 'PSMS_SETTLEMENTS_DETAILS_FAILURE';
export const PSMS_SETTLEMENTS_DETAILS_LOADING = 'PSMS_SETTLEMENTS_DETAILS_LOADING';

// PSMS Accounts Receivable Summary Actions
export const PSMS_AR_SUMMARY_REQUEST = 'PSMS_AR_SUMMARY_REQUEST';
export const PSMS_AR_SUMMARY_SUCCESS = 'PSMS_AR_SUMMARY_SUCCESS';
export const PSMS_AR_SUMMARY_FAILURE = 'PSMS_AR_SUMMARY_FAILURE';
export const PSMS_AR_SUMMARY_LOADING = 'PSMS_AR_SUMMARY_LOADING';
//PSMS Extended TIN Details
export const PSMS_EXTENDED_TIN_DETAIL_REQUEST = 'PSMS_EXTENDED_TIN_DETAIL_REQUEST';
export const PSMS_EXTENDED_TIN_DETAIL_SUCCESS = 'PSMS_EXTENDED_TIN_DETAIL_SUCCESS';
export const PSMS_EXTENDED_TIN_DETAIL_FAILURE = 'PSMS_EXTENDED_TIN_DETAIL_FAILURE';
export const PSMS_EXTENDED_TIN_DETAIL_LOADING = 'PSMS_EXTENDED_TIN_DETAIL_LOADING';

// PSMS Prior Authorization Actions
export const PSMS_PA_CASE_SUBMISSION_REQUEST = 'PSMS_PA_CASE_SUBMISSION_REQUEST';
export const PSMS_PA_CASE_SUBMISSION_SUCCESS = 'PSMS_PA_CASE_SUBMISSION_SUCCESS';
export const PSMS_PA_CASE_SUBMISSION_FAILURE = 'PSMS_PA_CASE_SUBMISSION_FAILURE';
export const PSMS_PA_CASE_SUBMISSION_LOADING = 'PSMS_PA_CASE_SUBMISSION_LOADING';

export const PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST = 'PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST';
export const PSMS_PA_CASE_SUBMISSION_CHANNEL_SUCCESS = 'PSMS_PA_CASE_SUBMISSION_CHANNEL_SUCCESS';
export const PSMS_PA_CASE_SUBMISSION_CHANNEL_FAILURE = 'PSMS_PA_CASE_SUBMISSION_CHANNEL_FAILURE';
export const PSMS_PA_CASE_SUBMISSION_CHANNEL_LOADING = 'PSMS_PA_CASE_SUBMISSION_CHANNEL_LOADING';

export const PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST = 'PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST';
export const PSMS_PA_APPROVAL_DENIAL_TREND_SUCCESS = 'PSMS_PA_APPROVAL_DENIAL_TREND_SUCCESS';
export const PSMS_PA_APPROVAL_DENIAL_TREND_FAILURE = 'PSMS_PA_APPROVAL_DENIAL_TREND_FAILURE';
export const PSMS_PA_APPROVAL_DENIAL_TREND_LOADING = 'PSMS_PA_APPROVAL_DENIAL_TREND_LOADING';

export const PSMS_PA_TAT_TREND_REQUEST = 'PSMS_PA_TAT_TREND_REQUEST';
export const PSMS_PA_TAT_TREND_SUCCESS = 'PSMS_PA_TAT_TREND_SUCCESS';
export const PSMS_PA_TAT_TREND_FAILURE = 'PSMS_PA_TAT_TREND_FAILURE';
export const PSMS_PA_TAT_TREND_LOADING = 'PSMS_PA_TAT_TREND_LOADING';

// Advance Search Dropdown Actions
export const ADVANCE_SEARCH_DATA_REQUEST = 'ADVANCE_SEARCH_DATA_REQUEST';
export const ADVANCE_SEARCH_DATA_SUCCESS = 'ADVANCE_SEARCH_DATA_SUCCESS';
export const ADVANCE_SEARCH_DATA_FAILURE = 'ADVANCE_SEARCH_DATA_FAILURE';
export const ADVANCE_SEARCH_DATA_LOADING = 'ADVANCE_SEARCH_DATA_LOADING';

// Overpayment Subcategory (on-demand) Actions
export const OVERPAYMENT_SUBCATEGORY_REQUEST = 'OVERPAYMENT_SUBCATEGORY_REQUEST';
export const OVERPAYMENT_SUBCATEGORY_SUCCESS = 'OVERPAYMENT_SUBCATEGORY_SUCCESS';
export const OVERPAYMENT_SUBCATEGORY_FAILURE = 'OVERPAYMENT_SUBCATEGORY_FAILURE';
export const OVERPAYMENT_SUBCATEGORY_LOADING = 'OVERPAYMENT_SUBCATEGORY_LOADING';

// NonPayment SubCategory on-demand fetch
export const NONPAYMENT_SUBCATEGORY_REQUEST = 'NONPAYMENT_SUBCATEGORY_REQUEST';
export const NONPAYMENT_SUBCATEGORY_SUCCESS = 'NONPAYMENT_SUBCATEGORY_SUCCESS';
export const NONPAYMENT_SUBCATEGORY_FAILURE = 'NONPAYMENT_SUBCATEGORY_FAILURE';
export const NONPAYMENT_SUBCATEGORY_LOADING = 'NONPAYMENT_SUBCATEGORY_LOADING';

// Impact Redirect Actions
export const FETCH_IMPACT_REDIRECT_REQUEST = 'FETCH_IMPACT_REDIRECT_REQUEST';
export const FETCH_IMPACT_REDIRECT_SUCCESS = 'FETCH_IMPACT_REDIRECT_SUCCESS';
export const FETCH_IMPACT_REDIRECT_FAILURE = 'FETCH_IMPACT_REDIRECT_FAILURE';
export const FETCH_IMPACT_REDIRECT_LOADING = 'FETCH_IMPACT_REDIRECT_LOADING';

// HomePage Search Store Actions (migrated from Zustand useHomePageStore)
export const SET_SELECTED_TAB = 'SET_SELECTED_TAB';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const SET_SEARCH_OPTION = 'SET_SEARCH_OPTION';
export const SET_SEARCH_OPTION_BACKUP = 'SET_SEARCH_OPTION_BACKUP';
export const SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';
export const SET_HEALTH_SYSTEM_VALUE = 'SET_HEALTH_SYSTEM_VALUE';
export const SET_GENESIS_ID = 'SET_GENESIS_ID';
export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_TIN_VALUE = 'SET_TIN_VALUE';
export const SET_TEMPLATE_VALUE = 'SET_TEMPLATE_VALUE';
export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';
export const SET_IS_SEARCH_LOADER = 'SET_IS_SEARCH_LOADER';
export const SET_TOP_SEARCHED_LIST = 'SET_TOP_SEARCHED_LIST';
export const SET_IS_ERROR = 'SET_IS_ERROR';
export const SET_IS_MESSAGE = 'SET_IS_MESSAGE';
export const SET_USER_DETAIL = 'SET_USER_DETAIL';

// Claims Reporting Actions

export const FETCH_SAVED_CLAIMS_REPORTS_REQUEST = 'FETCH_SAVED_CLAIMS_REPORTS_REQUEST';
export const FETCH_SAVED_CLAIMS_REPORTS_SUCCESS = 'FETCH_SAVED_CLAIMS_REPORTS_SUCCESS';
export const FETCH_SAVED_CLAIMS_REPORTS_FAILURE = 'FETCH_SAVED_CLAIMS_REPORTS_FAILURE';
export const FETCH_SAVED_CLAIMS_REPORTS_LOADING = 'FETCH_SAVED_CLAIMS_REPORTS_LOADING';

export const SAVE_CLAIMS_REPORT_PARAMETERS_REQUEST = 'SAVE_CLAIMS_REPORT_PARAMETERS_REQUEST';
export const SAVE_CLAIMS_REPORT_PARAMETERS_SUCCESS = 'SAVE_CLAIMS_REPORT_PARAMETERS_SUCCESS';
export const SAVE_CLAIMS_REPORT_PARAMETERS_FAILURE = 'SAVE_CLAIMS_REPORT_PARAMETERS_FAILURE';
export const SAVE_CLAIMS_REPORT_PARAMETERS_LOADING = 'SAVE_CLAIMS_REPORT_PARAMETERS_LOADING';

export const GENEREATE_PREVIEW_CLAIMS_REPORT_REQUEST = 'GENEREATE_PREVIEW_CLAIMS_REPORT_REQUEST';
export const GENEREATE_PREVIEW_CLAIMS_REPORT_SUCCESS = 'GENEREATE_PREVIEW_CLAIMS_REPORT_SUCCESS';
export const GENEREATE_PREVIEW_CLAIMS_REPORT_FAILURE = 'GENEREATE_PREVIEW_CLAIMS_REPORT_FAILURE';
export const GENEREATE_PREVIEW_CLAIMS_REPORT_LOADING = 'GENEREATE_PREVIEW_CLAIMS_REPORT_LOADING';

export const UPDATE_CLAIMS_REPORTING_FIELDS = 'UPDATE_CLAIMS_REPORTING_FIELDS';
export const RESET_REPORT_STATE = 'RESET_REPORT_STATE';
export const RESET_REMOVE_REPORT_STATE = 'RESET_REMOVE_REPORT_STATE';

export const REMOVE_CLAIMS_REPORT_REQUEST = 'REMOVE_CLAIMS_REPORT_REQUEST';
export const REMOVE_CLAIMS_REPORT_SUCCESS = 'REMOVE_CLAIMS_REPORT_SUCCESS';
export const REMOVE_CLAIMS_REPORT_FAILURE = 'REMOVE_CLAIMS_REPORT_FAILURE';
export const REMOVE_CLAIMS_REPORT_LOADING = 'REMOVE_CLAIMS_REPORT_LOADING';

export const GENERATE_CONVERSATION_REQUEST = 'GENERATE_CONVERSATION_REQUEST';
export const GENERATE_CONVERSATION_SUCCESS = 'GENERATE_CONVERSATION_SUCCESS';
export const GENERATE_CONVERSATION_FAILURE = 'GENERATE_CONVERSATION_FAILURE';
export const GENERATE_CONVERSATION_LOADING = 'GENERATE_CONVERSATION_LOADING';

export const FETCH_SINGLE_CLAIMS_REPORT_REQUEST = 'FETCH_SINGLE_CLAIMS_REPORT_REQUEST';
export const FETCH_SINGLE_CLAIMS_REPORT_SUCCESS = 'FETCH_SINGLE_CLAIMS_REPORT_SUCCESS';
export const FETCH_SINGLE_CLAIMS_REPORT_FAILURE = 'FETCH_SINGLE_CLAIMS_REPORT_FAILURE';
export const FETCH_SINGLE_CLAIMS_REPORT_LOADING = 'FETCH_SINGLE_CLAIMS_REPORT_LOADING';

export const PRE_SELECT_TEMPLATE_FIELDS = 'PRE_SELECT_TEMPLATE_FIELDS';

export const EXPORT_REPORT_DATA_REQUEST = 'EXPORT_REPORT_DATA_REQUEST';
export const EXPORT_REPORT_DATA_SUCCESS = 'EXPORT_REPORT_DATA_SUCCESS';
export const EXPORT_REPORT_DATA_FAILURE = 'EXPORT_REPORT_DATA_FAILURE';
export const EXPORT_REPORT_DATA_LOADING = 'EXPORT_REPORT_DATA_LOADING';
